<style lang="stylus">
        .tabs
            z-index 21
            position fixed
            top 0
            left 0
            right 0

            div
                user-select none

            .tabs-topbar
                position relative
                height 32px
                background-color transparent
                display flex
                justify-content space-between

                .item-icon
                    cursor pointer
                    z-index 1

                .tabs-left
                    display flex
                    align-items center

                    .back2home
                        width 30px
                        padding-left 10px
                        font-size 14px
                        display flex
                        justify-content center
                        align-items center
                        margin-right 10px
                        cursor: pointer;
                        opacity: 0.8;
                        &:hover{
                            opacity 1;
                        }
                        svg
                            width 20px
                            height 20px
                            pointer-events none
                    .svg-box
                        width 32px
                        height 32px
                        padding 4px
                        cursor pointer
                        border-radius 6px
                        &.home-logo
                            width 24px;
                            height 24px;
                            padding 0;
                            position relative
                            .step-wrapper
                                position absolute
                                width 36px
                                height 36px
                                margin -6px
                                z-index -1
                                top 0
                                &::before
                                    content ''
                                    width 100%
                                    height 100%
                                    display block
                                    background var(--color-white)
                                    border-radius 6px
                            .step-wrapper.shepherd-target
                                background rgba(0,0,0,0.5)
                        img
                            width 100%
                        &:hover
                            background var(--bg-color-tabpanel-btn-hover)
                        &.top-menu-active:hover
                            // background none;
                    // .home-logo

                    .save-svg,.star-svg
                        // width 32px
                        // height 32px
                        img
                         padding 4px
                    .star-svg
                        display flex
                        justify-content center
                        align-items center
                        margin 0 8px

                    .star-icon
                        width 16px
                        height 16px

                    .menu-icon
                        stroke var(--svg-color-primary)
                        width 24px
                        height 24px
                    .top-menu-active
                        background var(--bg-color-top-menu-active)!important
                        .menu-icon
                            stroke var(--svg-color-active)

                    .logo-line
                        width 1px
                        height 24px
                        margin 0 12px
                        background var(--bg-color-logo-line)


                    .reName-box
                        position relative
                        margin 0 auto
                        display flex
                        align-items center

                        div
                            user-select auto !important

                        &:hover .item-rename
                            display block

                        span
                            color var(--text-color-primary) !important

                        .reName
                            color #000
                            padding 0
                            max-width 400px
                            min-width 87px
                            border unset
                            // height 32px
                            text-overflow ellipsis
                            white-space nowrap
                            // opacity 0.8
                            // &:hover
                            //     opacity 0.8
                            >span
                                color var(--text-color-primary) !important
                                font-size 14px
                                font-style normal
                                font-weight 700
                                line-height 18px /* 128.571% */

                            input
                                display block
                                outline none
                                padding 0
                                appearance none
                                text-indent unset
                                line-height 32px
                                font-size 12px

                            input:focus
                                outline-offset 0

                            .input-tips
                                display none

                        .click-text
                            height unset
                            .hide-text
                                display none
                            .edit-input
                                height unset
                                position unset
                                width: unset
                                color var(--text-color-primary) !important
                                font-size 14px
                                font-weight 700
                                margin-bottom -2px
                                &::selection
                                    background var(--text-color-file-name-edit-select)


                        .splice-line
                            height 24px
                            width 1px
                            background #E0E0E0

                        .item-rename
                            color #fff
                            width 13px
                            height 13px
                            cursor pointer
                            margin-left 10px

                        .tabs-icon
                            position relative
                            // margin 0 8px
                            // width 20px
                            // height 32px
                            // margin-left 16px

                            &:hover
                                svg
                                    opacity 1


                            >svg
                                cursor pointer
                                position absolute
                                top 50%
                                left 50%
                                transform translate(-50%,-50%)
                                width 20px
                                height 20px
                                opacity .8

                            .activeFunc
                                background-color var(--themeActived)

                        .save-icon
                            margin 0 8px
                            .save-svg
                                padding 8px;
                                svg
                                    height 16px;
                                    width 16px
                                    color: var(--svg-color-primary);
                        .item-icon
                            stroke var(--svg-color-gray-42)
                            fill none
                            // &:hover
                            //     fill: #424242


                        .item-star-active
                            stroke var(--file-star-color)
                            fill var(--file-star-color)
                            // &:hover
                            //     fill #fa782f
                            //     stroke #fa782f



                        .tabs-saveTips
                            margin-left 16px
                            line-height 34px
                            color #888

                        .save-loading
                            width 20px
                            height 20px
                            margin-left 10px
                            @keyframes ldio-vl3uzqovzc
                                0%  {
                                    transform translate(-50%,-50%) rotate(0deg)
                                }
                                100%  {
                                    transform translate(-50%,-50%) rotate(360deg)
                                }

                            .ldio-vl3uzqovzc div
                                position absolute
                                width 66px
                                height 66px
                                border 4px solid var(--themeColor)
                                border-top-color transparent
                                border-radius 50%

                            .ldio-vl3uzqovzc div
                                animation ldio-vl3uzqovzc 1s linear infinite
                                top 50px
                                left 50px

                            .loadingio-spinner-rolling-ffv2b7h2vv6
                                width 20px
                                height 20px
                                display inline-block
                                overflow hidden
                                background none

                            .ldio-vl3uzqovzc
                                width 100%
                                height 100%
                                position relative
                                transform translateZ(0) scale(0.2)
                                backface-visibility hidden
                                transform-origin 0 0 /* see note above */

                            .ldio-vl3uzqovzc div
                                box-sizing content-box


                    .groupView-namebox
                        pointer-events none

                        >div
                            position relative
                            display inline-block
                            padding 0 20px
                            height 30px
                            line-height 30px
                            border-bottom-left-radius 3px
                            border-bottom-right-radius 3px
                            pointer-events auto

                            p
                                display inline
                                color #000
                                font-size 12px

            .tabs-layer
                user-select none
                color #333
                width 100%
                height 24px
                position relative
                display flex
                white-space nowrap
                justify-content space-between

                .tabs-left
                    display flex
                    user-select none
                    text-align center
                    font-size 14px
                    margin-left: 10px
                    .tabs-file
                        width 66px
                        display inline-block
                        line-height 32px

                    .tabs-main
                        display flex
                        flex-wrap nowrap
                        .tabs-menu
                            position relative
                            user-select none
                            cursor pointer
                            font-size 12px
                            user-select none
                            margin 0 0
                            padding 0 20px
                            height 100%
                            line-height 24px
                            border-radius: 8px 8px 0 0;
                            &:hover
                                background-color #fff
                            img
                                position absolute
                                top -12px
                                bottom 0
                                right -6px
                                width 24px
                                height 24px
                                z-index 9

                        .tabs-icon
                            position relative
                            width 65px
                            height 100%
                            &:hover
                                svg
                                    opacity 1

                            >svg
                                cursor pointer
                                position absolute
                                top 50%
                                left 50%
                                transform translate(-50%,-50%)
                                width 20px
                                height 20px
                                opacity .8

                            .activeFunc
                                background-color var(--themeActived)


                        .activedTab
                            background-color $item-active-color

                .tabs-right
                    display flex
                    text-align center
                    font-size 14px

                    .en-tab
                        width 300px !important

                    .tabs-add
                        position relative
                        margin-right 20px
                        justify-content space-around
                        display flex
                        align-items center
                        flex-wrap nowrap
                        padding-left 20px
                        .tabs-icon
                            position relative
                            width 32px
                            height 32px
                            &:hover
                                svg
                                    opacity 1

                            >svg
                                cursor pointer
                                position absolute
                                top 50%
                                left 50%
                                transform translate(-50%,-50%)
                                width 20px
                                height 20px
                                opacity .8

                            .activeFunc
                                background-color var(--themeActived)



                        .present-container
                            z-index 1
                            border-radius 3px
                            background-color #e0e0e0
                            display flex
                            cursor pointer
                            span
                                user-select none

                            .ivu-poptip-rel
                                display block

                            svg
                                width 16px
                                height 16px

                            .presentF
                                border-left 1px solid #c4c4c4
                                width fix-content
                                display flex
                                align-items center
                                border-top-right-radius 3px
                                border-bottom-right-radius 3px
                                >svg
                                    margin-left 10px

                                >span
                                    margin-right 10px
                                    height 16px
                                    line-height 16px

                                &:hover
                                    background-color #c4c4c4


                            .activeFunc
                                background-color var(--themeActived)
                                span
                                    color #fff


                        .present-box
                            cursor pointer
                            width 36px
                            height 24px
                            display flex
                            border-top-left-radius 3px
                            border-bottom-left-radius 3px
                            align-items center
                            justify-content center

                            &:hover
                                background-color #c4c4c4

                            >span
                                height 20px
                                line-height 20px

                            >div
                                width 18px
                                height 20px
                                margin-left 4px
                                padding 2px 1px
                                >svg
                                    position relative
                                    top -1px

                        .activeFunc
                            background-color var(--themeActived)
                            span
                                color #fff


                        .expand-box
                            margin-top 6px
                            background-color white
                            border 1px solid #e0e0e0
                            z-index 10
                            padding 4px 10px
                            position fixed
                            width 150px
                            height 30px



            .tabs-container
                height 40px
                display flex
                background-color $navigation-backcolor


            .groupLock-modal
                position fixed
                display flex
                justify-content center
                align-items center
                z-index 10
                left 0
                top 0
                width 100vw
                height 100vh
                .groupLock-box
                    display flex
                    justify-content center
                    flex-wrap wrap
                    width 355px
                    padding 36px 0
                    background #FAFAFA
                    border 0.5px solid rgba(0, 0, 0, 0.104759)
                    box-shadow 0px 4px 8px rgba(0, 0, 0, 0.1), 0px 8px 16px rgba(0, 0, 0, 0.0982299)
                    border-radius 6px
                    .groupLock-user
                        display flex
                        justify-content center
                        align-items center
                        width 100%
                        img
                            width 40px
                            height 40px
                            border-radius 50%
                            margin-right 10px

                        p
                            font-size 14px
                            color #000
                            max-width 200px
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                        .no-icon
                            display block
                            width 40px
                            height 40px
                            margin-right 10px
                            line-height 40px
                            text-align center
                            color #7A5923
                            font-size 14px
                            background #FFF8E5
                            border-radius 50%
                            cursor pointer
                            border:2px solid $box-bordercolor;

                    .groupLock-remind
                        width 100%
                        font-size 14px
                        color #000
                        text-align center
                        margin 10px 0 20px 0

                    .groupLock-btnbox
                        text-align center
                        padding-right 0

        .tab-tool
            height 48px
            display flex
            justify-content space-between
            align-items center
            border-bottom 1px solid var(--border-color-gray2)
            box-sizing unset
            background-color var(--bg-color-primary)
            // background: #EEF0F5;

            .tool-left
                padding-left 12px
                // height 63px
            .tool-right
                display flex
                align-items center
                padding-right 12px
                .tabs-right
                    display flex
                    position relative
                    align-items center
                    float right
                    height 28px
                    >div
                        color #fff
                    .change-theme
                        color: var(--text-color-primary)
                    .tabs-theme
                        margin-right 20px
                        .tabs-icon
                            position relative
                            width 40px
                            height 32px
                            cursor pointer
                            &:hover
                                svg
                                    opacity 1

                            .theme-icon
                                cursor pointer
                                position absolute
                                top 50%
                                left 50%
                                transform translate(-50%,-50%)
                                width 20px
                                height 20px
                                opacity .8

                            .activeFunc
                                background-color var(--themeActived)


                        .theme-arrow
                            position absolute
                            right 0
                            top 12px
                            width 8px
                            height 8px
                            fill #424242

                        .tips-dropbox
                            padding 4px 0
                            position absolute
                            right 0
                            top 35px
                            background-color white
                            color #000
                            box-shadow $common-box-shadow
                            border-radius 4px
                            font-size 12px
                            overflow hidden
                            z-index 1
                            outline none

                    .topbar-buybox.vip-btn
                        cursor: pointer;
                        position relative
                        display flex
                        align-items center
                        height 100%
                        white-space nowrap
                        margin-right 16px
                        background linear-gradient(0deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.15)), linear-gradient(95.48deg, #FFDD63 9.58%, #FFC552 92.27%), linear-gradient(95.48deg, #FFD363 9.58%, #FFC552 92.27%);
                        color #4A320E
                        font-weight bold
                    .btn-wrapper
                        position relative
                        padding: 8px 0;
                        .vip-popover
                            position absolute
                            top 44px
                            left 0
                            z-index 1000
                            display none
                            &.used-vip
                                left -16px
                        &:hover
                            .vip-popover
                                display block !important
                    .vip-btn2
                        display flex
                        align-items center
                        position relative
                        height 32px
                        padding 0 16px 0 12px
                        border-radius 6px
                        font-size 12px
                        cursor pointer
                        // width 100%
                        // white-space nowrap
                        // overflow hidden
                        // text-overflow ellipsis
                        transition all .2s linear
                        background linear-gradient(104.04deg, #381A00 0%, #1D0D00 100%)
                        color #FFD298
                        margin-right 12px
                        &:hover
                            background linear-gradient(104.04deg, #381A00 0%, #1D0D00 100%)
                        img
                            width 24px
                            height 24px
                            margin-right 4px
                        #topbar-buybox_word
                            white-space nowrap
                            overflow hidden
                            text-overflow ellipsis
                            max-width 150px


                    .tabs-icon-btn
                        display flex
                        justify-content center
                        align-items center
                        min-width 70px
                        height 28px
                        padding 0 12px 0 8px
                        border-radius 20px
                        background #6cf
                        cursor pointer
                        flex-shrink 0
                        @media screen and (max-width: 800px)
                            display none
                        >svg
                            width 24px
                            height 24px
                            margin-right 2px

                        >span
                            padding 0
                            font-size 12px


                    .publish-btn
                        border-color var(--themeColor)
                        background-color var(--themeColor)
                        &:hover{
                          background-color: var(--themeHover)
                        }
                        >svg
                            fill #fff

                        >span
                            color #fff

                    .share-btn
                        display: flex;
                        align-items: center;
                        background-color #fff
                        border-color #e5e5e5
                        margin-left 16px
                        &:hover{
                          background-color: rgba(255,255,255,0.8);
                        }
                        &.activeFunc
                            background-color var(--themeActived)
                            >span
                                color #fff
                            >svg
                                fill #fff
                        >svg
                            fill #424242

                        >span
                            color #424242

                    .tabs-publish-guidebox
                        width 272px
                        position absolute
                        right 85px
                        top 40px
                        z-index 1
                        padding 16px
                        border-radius 8px
                        background var(--bg-color-tips)
                        border 0.5px solid rgba(255, 255, 255, 0.2)
                        box-shadow 0px 0px 4px rgba(0, 0, 0, 0.05), 0px 2px 10px rgba(0, 0, 0, 0.08)
                        backdrop-filter blur(2px)
                        .ednotice-arrow
                            position absolute
                            transform rotate(180deg)
                            right 30px
                            top -12px

                        p
                            text-align left
                            font-size 12px
                            line-height 16px
                            color #fff

                        .guidebox-title
                            font-size 12px
                            font-weight 700
                            margin-bottom 8px

                        .guidebox-content
                            font-size 12px
                            line-height 20px
                            white-space break-spaces
                            .guidebox-svg
                                vertical-align middle

                        .guidebo-btn
                            display inline-block
                            padding 4px 10px
                            background #017EFF
                            border-radius 6px
                            color #fff
                            font-size 12px
                            text-align center
                            float right
                            border-radius 6px
                            margin-top 10px
                            cursor pointer
                            user-select none
                    .tabpanel-helpbtn
                        margin-right 16px
                        z-index 1
                    .tabpanel-userbtn
                        margin-left 16px
                    .line
                        height 24px
                        width 1px
                        background var(--border-color-gray2)
                    .user-line
                        // height 24px
                        // width 1px
                        // background rgba(0,0,0,0.08)
                        margin-left 16px
                    .export-btn
                        position relative
                        .main-drops
                            padding 8px
                            position absolute
                            top 36px
                            left 0px
                            color var(--text-color-primary)
                        .btn-box
                            color var(--text-color-primary)
                            margin-right 10px
                            display flex
                            align-items center
                            height 32px
                            padding 4px 16px 4px 12px
                            border 1px solid var(--border-color-gray2)
                            border-radius 6px
                            cursor pointer
                            &:hover
                                background var(--bg-color-tabpanel-btn-hover)
                            svg
                                width 24px;
                                height 24px;
                                margin-right 4px;
                                color: var(--svg-color-primary);
                        .btn-box__no-margin-right
                            margin-right 0px
                    .publish-share-btn
                        cursor pointer
                        display flex
                        align-items center
                        position relative
                        // &:hover
                        //     opacity 0.9
                        .btn
                            background var(--themeColor)
                            color #fff
                            height 32px
                            line-height 32px
                        .btn-left
                            padding 0px 16px
                            border-radius 6px 0 0 6px
                        .btn-right
                            border-radius 0 6px 6px 0
                            width 32px
                            height 32px
                            border-left 1px solid rgba(0,0,0,0.12)
                            display flex
                            align-items center
                            justify-content center
                            svg
                                width 10px
                                height 6px;
                                // 这种不需要改
                                color: #fff;
                        .publish-btn
                            position absolute
                            top 34px
                            right 0
                            background var(--bg-color-white)
                            border-radius 6px
                            min-width 92px
                            height 44px
                            text-align center
                            line-height 44px
                            padding 0px 10px
                            z-index 100
                            box-shadow 0 4px 6px rgba(0, 0, 0, 0.1)
                            color var(--text-color-primary)
                            white-space nowrap
                            &:hover
                                background var(--bg-color-tabpanel-btn-hover)
                                z-index 100
                        .step-wrapper
                            position absolute
                            width calc(100% + 12px);
                            height 44px
                            margin -6px
                            z-index -1
                            &::before
                                content ''
                                width 100%
                                height 100%
                                display block
                                background var(--color-white)
                                border-radius 6px
                        .step-wrapper.shepherd-target
                            background rgba(0,0,0,0.5)
                    .no-publish
                        .btn-left
                            border-radius 6px !important
                    .export-line
                        margin 0 16px 0 8px;
                    .right-icon
                        width 32px
                        height 32px
                        // padding 8px
                        border-radius 4px
                        cursor pointer
                        display flex
                        align-items center
                        justify-content center
                        flex-shrink 0
                        &:hover
                            background var(--bg-color-tabpanel-btn-hover)
                    .right-icon_active
                        background #f2f4f9
                    .comment-icon
                        img
                            width 18px
                            height 17px
                    .play-icon
                        position relative
                        svg
                            width 24px
                            height 24px
                            color: var(--svg-color-primary);
                        .main-drops
                            padding 6px
                            position absolute
                            top 36px
                            left 0px
                            color var(--text-color-primary)
                            min-width: 104px;
                            border none;
                            box-shadow var(--box-shadow-color-box)
                            &:before
                                content: '';
                                height: 14px;
                                width: 40px;
                                background-color: transparent;
                                top: -10px;
                                left: 0;
                                position: absolute;
                    .comment-icon
                        margin-right 8px

            .tool-edit
                display flex
                align-items center
                column-gap 8px
                margin 0 auto
                .tabs-icon-btn
                    display flex
                    justify-content center
                    align-items center
                    background var(--themeColor)
                    color #fff
                    height 32px
                    line-height 32px
                    padding 0 16px
                    border-radius 6px
                    cursor pointer
                    user-select none
                    @media screen and (max-width: 800px)
                        display none

                    >span
                        padding 0
                        font-size 12px


        .group-tab
            height 64px
            background #fff
            display flex
            justify-content space-between
            .group-left
                height 64px
                display flex
                align-items center
                margin-right auto
                .work-return
                    width 60px
                    padding 0 10px
                    height 100%
                    display flex
                    justify-content center
                    align-items center
                    flex-shrink 0
                    &:hover
                        svg
                            fill var(--themeColor)
                    svg
                        width 24px
                        height 24px
                        fill #424242
                        cursor pointer
                .work-title
                    margin-right auto
                    font-size 18px
                    flex 0 0 350px
                    box-sizing border-box
                    max-width 500px
                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap
            .group-right
                display flex
                height 64px
                align-items center
                .board-edit
                    display flex
                    justify-content center
                    align-items center
                    height 32px
                    padding 0 12px
                    margin-right 16px
                    color #fff
                    font-size 12px
                    background var(--themeColor)
                    border-radius 5px
                    box-sizing border-box
                    user-select none
                    cursor pointer
                    svg
                        width 20px
                        height 20px
                        margin-right 4px
                    &:hover
                        background #0977ea
                .groupView-edit
                    height 32px
                    padding 5px 15px
                    margin-right 10px
                    border 1px solid var(--themeColor)
                    border-radius 3px
                    line-height 20px
                    text-align center
                    user-select none
                    cursor pointer
                    margin-right 16px
                    span
                        font-size 12px
                        color var(--themeColor)
                .groupView-userbtn
                    margin-left 16px
                    margin-right 16px

                .topbar-buybox
                    position relative
                    display flex
                    align-items center
                    height 100%
                    white-space nowrap
                    margin-right 16px
                .vip-btn
                    position relative
                    height 32px
                    padding 0 16px
                    color #4A320E
                    background linear-gradient(0deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.15)), linear-gradient(95.48deg, #FFDD63 9.58%, #FFC552 92.27%), linear-gradient(95.48deg, #FFD363 9.58%, #FFC552 92.27%);
                    border-radius 210px
                    line-height 32px
                    text-align center
                    font-size 12px
                    font-weight bold
                    cursor pointer
                    width 100%
                    white-space nowrap
                    overflow hidden
                    text-overflow ellipsis
                    transition all .2s linear
                    &:hover
                        background linear-gradient(95.48deg, #FFDD63 9.58%, #FFC552 92.27%), linear-gradient(95.48deg, #FFD363 9.58%, #FFC552 92.27%);

                    @media screen and (max-width: 1200px)
                        display none

                .publish-btn
                    display inline-block
                    line-height 30px
                    min-width 75px
                    height 32px
                    padding 0 8px
                    border-radius 5px
                    vertical-align middle
                    border 1px solid var(--themeColor)
                    cursor pointer
                    flex-shrink 0
                    background-color var(--themeColor)
                    &:hover{
                      background-color: var(--themeHover)
                    }
                    @media screen and (max-width: 800px)
                        display none
                    >svg
                        width 20px
                        height 20px
                        padding 0
                        opacity .8
                        vertical-align middle
                        margin-right 7px
                        fill #fff

                    >span
                        padding 0
                        font-size 12px
                        color #fff

                .share-btn
                    display inline-block
                    line-height 30px
                    min-width 75px
                    height 32px
                    padding 0 8px
                    border-radius 5px
                    vertical-align middle
                    border 1px solid #e5e5e5
                    cursor pointer
                    flex-shrink 0
                    background #fff
                    border-color #e5e5e5
                    margin-left 12px
                    margin-right 10px
                    @media screen and (max-width: 800px)
                        display none
                    &.activeFunc
                        background-color var(--themeActived)
                        >span
                            color #fff
                        >svg
                            fill #fff
                    >svg
                        width 20px
                        height 20px
                        padding 0
                        opacity .8
                        vertical-align middle
                        margin-right 7px
                        fill #424242

                    >span
                        color #424242

        .tabs-board
            height 64px !important
            display flex
            align-items center
            border-bottom 1px solid #e0e0e0
            .tabs-board-btn
                display flex
                justify-content center
                align-items center
                height 32px
                padding 0 12px
                margin-right 16px
                color #fff
                font-size 12px
                background var(--themeColor)
                border-radius 5px
                box-sizing border-box
                user-select none
                cursor pointer
                svg
                    width 20px
                    height 20px
                    margin-right 4px
                &:hover
                    background #0977ea
    .tabs-right-fit
        .userMenu
            margin-left 12px !important
        .export-btn
            .btn-box
                margin-right 12px !important
            .btn-box__no-margin-right
                margin-right 0px !important
        .export-line
            margin-left 8px !important
</style>
<i18n>
{
  "zh": {
    "ai": "AI",
    "language": "语言设置",
    "file": "文件",
    "edit": "编辑",
    "select": "选择",
    "insert": "插入",
    "arrange": "布局",
    "view": "视图",
    "help": "帮助",
    "symbol": "符号",
    "hide": "隐藏",
    "show": "显示",
    "fullScreen": "全屏视图",
    "searchFunc": "功能查找",
    "plugin": "插件",
    "themeFunc": "主题色",
    "saveFile": "保存",
    "downloadFile": "下载文件",
    "outputFile": "导出文件",
    "printFile": "打印文件",
    "shareFile": "分享文件",
    "encryptFile": "文档加密",
    "remindMsg": "分享文件已存在，是否覆盖？",
    "remindMsgExtra": "（覆盖后当前的分享链接将会显示最新的文件）",
    "timeout": "请求超时，请检查网络",
    "autoSaving": "自动保存中...",
    "saving": "保存中...",
    "autoSaved": "保存完成",
    "saveSuccess": "保存成功",
    "space": "保存失败，云空间已达上限， 删除文件或清理回收站",
    "renameFail": "重命名失败，名字不能包含特殊字符(& % $ \\ \/ \" : * ? < > | . 😊等)",
    "feedback": "反馈中心",
    "sameName": "已存在同名文件，请重新命名",
    "noEmpty": "文件名不能为空！",
    "present": "演示",
    "pagePresent": "页面演示",
    "presentTip": "开始页面演示或自定义演示。",
    "tip": "Edraw 提醒",
    "saveTip": "文档有改动尚未保存，是否现在保存？",
    "confirm": "确认",
    "cancel": "取消",
    "vip": "开通VIP",
    "publishWork": "发布",
    "vipTips": "<b>升级会员</b> 即可使用无限的形状及文档，并支持同时使用桌面端亿图图示！",
    "editShared": "文件已分享，请勿重复分享",
    "lockedFile": "文件已加密，请解密后再分享文件",
    "startEdit": "开始编辑",
    "groupRemind": "当前已有用户正在编辑",
    "guideBoxTitle": "要同时发布作品到社区吗？",
    "guideBoxContent": "发布作品不仅可以分享知识，还可以赚钱哦~（月收益最高可达千元）",
    "guideBoxConfirm": "我知道了",
    "share": "分享",
    "publish": "发布",

    "return": "返回",
    "publishToStore": "发布到社区",
    "output": "导出",
    "collect": "收藏",
    "comment": "评论",
    "newFileName": "未命名文件",
    "nologinTips": "当前文件未保存，创建或登录账户后即可保存并随时编辑。",
    "diagramTitle": "图表文件"
  },
  "en": {
    "ai": "AI",
    "language": "Language Setting",
    "file": "File",
    "edit": "Edit",
    "select": "Select",
    "insert": "Insert",
    "arrange": "Layout",
    "view": "View",
    "help": "Help",
    "symbol": "Symbol",
    "hide": "Hide",
    "show": "Show",
    "fullScreen": "Full Screen",
    "searchFunc": "Search Feature",
    "plugin": "Plugin",
    "themeFunc": "Theme",
    "saveFile": "Save",
    "downloadFile": "Download",
    "outputFile": "Export",
    "printFile": "Print",
    "shareFile": "Share",
    "encryptFile": "Encrypt",
    "remindMsg": "Shared file already exists, do you want to replace it?",
    "remindMsgExtra": "(Share link will show the latest file after overiding)",
    "timeout": "Request timeout, please check the network.",
    "autoSaving": "Auto saving",
    "saving": "Saving",
    "autoSaved": "Saved",
    "saveSuccess": "Save Successfully.",
    "space": "Save failed, space storage not enough. Please delete Edraw files or clean your recycle bin.",
    "renameFail": "Rename failed, check if the name contains special character, such as & % $ \\ \/ \" : * ? < > | . 😊, etc.",
    "feedback": "Feedback",
    "sameName": "A file with the same name already exists. Please rename it.",
    "noEmpty": "File name cannot be empty.",
    "present": "Present",
    "pagePresent": "Present Pages",
    "presentTip": "Start page presentation or custom presentation.",
    "tip": "Edraw tips",
    "saveTip": "The document has been changed. Do you want to save now?",
    "confirm": "OK",
    "cancel": "Cancel",
    "vip": "Upgrade",
    "publishWork": "Publish",
    "vipTips": "<b>Upgrade members </b> can use unlimited shapes and documents, and support to use the desktop Edrawmax simultaneously!",
    "editShared": "Document is shared!",
    "lockedFile": "The file is encrypted, please decrypt it before sharing",
    "startEdit": "Start editing",
    "groupRemind": "There are currently users editing",
    "guideBoxTitle": "Publish your file to Template Community?",
    "guideBoxContent": "Publish your file to Template Community for sharing knowledge and making money. (monthly income can reach up to 1,000 RMB)",
    "guideBoxConfirm": "Confirm",
    "share": "Share",
    "publish": "Publish",

    "return": "Return",
    "output": "Export",
    "collect": "Favorites",
    "comment": "Comment",
    "publishToStore": "Publish to Community",
    "newFileName": "Unnamed File",
    "nologinTips": "Your edits aren't saved. Create a free account or sign in to save your work.",
    "diagramTitle": "Diagram File"
  },
  "fr": {
    "ai": "AI",
    "language": "Paramètres de langue",
    "file": "Fichier",
    "edit": "Modifier",
    "select": "Sélectionner",
    "insert": "Insérer",
    "arrange": "Disposition",
    "view": "Vue",
    "help": "Aide",
    "symbol": "Forme",
    "hide": "Masquer",
    "show": "Montrer",
    "fullScreen": "Mode plein écran",
    "searchFunc": "Recherche de Fonction",
    "themeFunc": "Couleur du thème",
    "saveFile": "Enregistrer",
    "downloadFile": "Télécharger",
    "outputFile": "Exporter le fichier",
    "printFile": "Imprimer",
    "shareFile": "Partager",
    "encryptFile": "Crypter",
    "remindMsg": "Fichier partagé existe déjà, voulez-vous le remplacer?",
    "remindMsgExtra": "(Le lien de partage actuel affichera le dernier fichier après l'écrasement)",
    "timeout": "La demande a expiré, veuillez vérifier le réseau",
    "autoSaving": "Sauvegarde Automatique...",
    "saving": "Sauvegarde...",
    "autoSaved": "Sauvegardé",
    "saveSuccess": "Enregistré avec succès",
    "space": "L'enregistrement a échoué, l'espace de stockage n'est pas suffisant. Veuillez supprimer les fichiers Edraw ou nettoyer votre corbeille Edraw.",
    "renameFail": "Changement de nom a échoué, vérifier si le nom contient un caractère spécial, tel que & % $ \\ \/ \" : * ? < > | . 😊, etc.\"",
    "feedback": "Centre de rétroaction",
    "sameName": "Un fichier du même nom existe déjà, veuillez le renommer",
    "noEmpty": "Nom de fichier ne peut pas être vide!",
    "present": "Démo",
    "pagePresent": "Démo Page",
    "presentTip": "Démarrer présentation de page ou présentation personnalisée.",
    "tip": "Rappel Edraw",
    "saveTip": "Le document n'a pas été enregistré. Voulez-vous l'enregistrer maintenant?",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "vip": "Mise à niveau vers Edition Professional",
    "publishWork": "Publier",
    "vipTips": "<b> Membre de mise à niveau </b> pour utiliser un nombre illimité de formes et de documents, et prendre en charge l'utilisation simultanée des icônes Edraw sur le bureau!",
    "editShared": "Le fichier a été partagé, veuillez ne pas le partager à plusieurs reprises",
    "lockedFile": "Le fichier est chiffré, veuillez le déchiffrer avant de le partager",
    "startEdit": "Commencer l'édition",
    "groupRemind": "Des utilisateurs modifient actuellement",

    "return": "retour",
    "output": "Exporter",
    "collect": "Favoris",
    "comment": "Commentaire",
    "publishToStore": "Publier",
    "nologinTips": "Vos modifications ne sont pas enregistrées. Créez un compte gratuit ou connectez-vous pour sauvegarder votre travail.",
    "diagramTitle": "Fichier de diagramme"
  },
  "de": {
    "ai": "AI",
    "language": "Sprache",
    "file": "Datei",
    "edit": "Bearbeiten",
    "select": "Auswählen",
    "insert": "Einfügen",
    "arrange": "Layout",
    "view": "Ansicht",
    "help": "Hilfe",
    "symbol": "Form bearbeiten",
    "hide": "Verbergen",
    "show": "Anzeigen",
    "fullScreen": "Vollbildsansicht",
    "searchFunc": "Suchen",
    "themeFunc": "Themenfarbe",
    "saveFile": "Datei speichern",
    "downloadFile": "Datei herunterladen",
    "outputFile": "Datei exportieren",
    "printFile": "Datei drucken",
    "shareFile": "Datei teilen",
    "encryptFile": "Verschlüsseln",
    "remindMsg": "Freigegebene Datei existiert bereits, möchten Sie sie ersetzen?",
    "remindMsgExtra": "(Der aktuelle Freigabelink zeigt die neueste Datei nach dem Überschreiben an.)",
    "timeout": "Timeout anfordern, bitte überprüfen Sie das Netzwerk.",
    "autoSaving": "Autospeichern...",
    "saving": "Speichern...",
    "autoSaved": "Gespeichert",
    "saveSuccess": "Erfolgreich gespeichert",
    "space": "Speichern fehlgeschlagen, Speicherplatz nicht ausreichend. Bitte löschen Sie Edraw-Dateien oder bereinigen Sie Ihren Edraw-Papierkorb.",
    "renameFail": "Umbenennen fehlgeschlagen, prüfen Sie, ob der Name Sonderzeichen wie & % $ \\ \/ \" : * ? < > | . 😊 usw. enthält",
    "feedback": "Rückmeldung",
    "sameName": "Eine gleichnamige Datei existiert bereits. Bitte benennen Sie sie um.",
    "noEmpty": "Dateiname darf nicht leer sein!",
    "present": "Präsentieren",
    "pagePresent": "Seite präsentieren",
    "presentTip": "Seitenpräsentation oder benutzerdefinierte Präsentation starten",
    "tip": "Edraw Tipps",
    "saveTip": "Das Dokument wurde geändert. Möchten Sie jetzt speichern?",
    "confirm": "Sichern",
    "cancel": "Abbrechen",
    "vip": "Auf Premium Version upgraden",
    "publishWork": "Veröffentlichen",
    "vipTips": "<b> Upgrade-Mitglieder </ b> können unbegrenzt viele Formen und Dokumente verwenden und die gleichzeitige Verwendung von Desktop-Edrawmax unterstützen!",
    "editShared": "Datei schon geteilt!",
    "lockedFile": "Die Datei ist verschlüsselt. Bitte entschlüsseln Sie sie vor dem Teilen",
    "startEdit": "Beginnen Sie die Bearbeitung",
    "groupRemind": "Derzeit bearbeiten Benutzer",
    "guideBoxTitle": "Veröffentlichen Sie Ihre Datei in der Vorlagen-Community?",
    "guideBoxContent": "Veröffentlichen Sie Ihre Datei in der Vorlagen-Community, um Wissen auszutauschen und Geld zu verdienen.",
    "guideBoxConfirm": "Bestätigen",

    "output": "Exportieren",
    "return": "Rückkehr",
    "collect": "Favoriten",
    "comment": "Kommentar",
    "publishToStore": "Veröffentlichen",
    "nologinTips": "Ihre Änderungen werden nicht gespeichert. Erstellen Sie ein kostenloses Konto oder melden Sie sich an, um Ihre Arbeit zu speichern.",
    "diagramTitle": "Diagrammdatei"
  },
  "jp": {
    "ai": "AI",
    "language": "言語",
    "file": "ファイル",
    "edit": "編集",
    "select": "選択",
    "insert": "挿入",
    "arrange": "レイアウト",
    "view": "表示",
    "help": "ヘルプ",
    "symbol": "図形",
    "hide": "非表示",
    "show": "表示",
    "fullScreen": "全画面表示",
    "searchFunc": "機能検索",
    "themeFunc": "テーマの色",
    "saveFile": "保存",
    "downloadFile": "ダウンロード",
    "outputFile": "ファイルをエクスポート",
    "printFile": "印刷",
    "shareFile": "共有",
    "encryptFile": "暗号化する",
    "remindMsg": "共有ファイルは既に存在します。上書きしますか",
    "remindMsgExtra": "（現在の共有リンクは、上書き後に最新のファイルが表示されます）",
    "timeout": "リクエストがタイムアウトしました。ネットワークを確認してください",
    "autoSaving": "自動保存中...",
    "saving": "保存中...",
    "autoSaved": "保存完了",
    "saveSuccess": "正常に保存されました",
    "space": "クラウドスペースが制限に達したため、保存に失敗しました。ファイルを削除するか、ごみ箱をクリアしてください。",
    "renameFail": "名前が要件を満たしていないため、名前の変更に失敗しました。",
    "feedback": "フィードバック",
    "sameName": "同じ名前のファイルが既に存在します。名前を変更してください",
    "noEmpty": "ファイル名を空にすることはできません！",
    "present": "プレゼンテーション",
    "pagePresent": "ページプレゼンテーション",
    "presentTip": "ページプレゼンテーションを開始するか、プレゼンテーションをカスタマイズする",
    "tip": "Edrawからのご注意",
    "saveTip": "ドキュメントは保存されていません。今すぐ保存しますか？",
    "confirm": "確認",
    "cancel": "キャンセル",
    "vip": "プロ版にアップグレード",
    "publishWork": "公開",
    "vipTips": "<b>会員をアップグレード</b>していただくと、すべての図形やドキュメントにアクセスでき、PC版のEdrawMaxも同時にご利用いただけます。",
    "editShared": "ファイルは共有されています。繰り返し共有しないでください",
    "lockedFile": "ファイルは暗号化されています。共有する前に復号化してください",
    "startEdit": "編集を開始",
    "groupRemind": "現在編集中のユーザーがいます",
    "share": "共有",
    "publish": "投稿",

    "output": "エクスポート",
    "return": "戻る",
    "collect": "お気に入り",
    "comment": "コメント",
    "publishToStore": "投稿",
    "nologinTips": "編集内容は保存されていません。無料アカウントを作成するか、サインインして作業を保存してください。",
    "diagramTitle": "ダイアグラムファイル"
  },
  "es": {
    "ai": "AI",
    "language": "Configuración de idioma",
    "file": "Archivo",
    "edit": "Editar",
    "select": "Seleccionar",
    "insert": "Insertar",
    "arrange": "Diseño",
    "view": "Ver",
    "help": "Ayuda",
    "symbol": "Símbolo",
    "hide": "Ocultar",
    "show": "Mostar",
    "fullScreen": "Pantalla completa",
    "searchFunc": "Buscar Caracteristica ",
    "themeFunc": "Color del tema",
    "saveFile": "Guardar",
    "downloadFile": "Descargar",
    "outputFile": "Exportar archivo",
    "printFile": "Imprimir",
    "shareFile": "Compartir",
    "encryptFile": "Cifrar",
    "remindMsg": "El archivo compartido ya existe, ¿quieres reemplazarlo?",
    "remindMsgExtra": "(El enlace actual de compartir mostrará el último archivo después de sobrescribirlo)",
    "timeout": "Solicito tiempo de espera, por favor, compruebe la red",
    "autoSaving": "Auto guardando",
    "saving": "guardando",
    "autoSaved": "Guardado",
    "saveSuccess": "Guardar con éxito.",
    "space": "El guardado falló, el almacenamiento no es suficiente. Por favor, borra los archivos de Edraw o limpia tu papelera de reciclaje de Edraw",
    "renameFail": "Renombrar el nombre falló, comprueba si el nombre contiene un carácter especial, como & % $ \\ \/ \" : * ? < > | . 😊, etc.",
    "feedback": "Comentarios",
    "sameName": "Ya existe un archivo con el mismo nombre. Por favor, cambie el nombre",
    "noEmpty": "El nombre del archivo no puede estar vacío",
    "present": "Presente",
    "pagePresent": "Presentación de la página",
    "presentTip": "Presentación de la página de inicio o presentación personalizada",
    "tip": "Consejos de Edraw",
    "saveTip": "El documento ha sido modificado. ¿Quieres guardar ahora?",
    "confirm": "Aceptar",
    "cancel": "Cancelar",
    "vip": "Actualizar a la versión Premium",
    "publishWork": "Lanzar",
    "vipTips": "¡Los <b> miembros de actualización </b> pueden usar formas y documentos ilimitados, y admitir el uso simultáneo de edrawmax de escritorio!",
    "editShared": "¡El documento está compartido!",
    "lockedFile": "El archivo está cifrado, descifrelo antes de compartirlo",
    "startEdit": "Iniciar la edición",
    "groupRemind": "Actualmente hay usuarios editando",

    "output": "Exportar",
    "return": "regreso",
    "collect": "Favoritos",
    "comment": "Contenedor",
    "publishToStore": "Publicar",
    "nologinTips": "Tus ediciones no se guardan. Crea una cuenta gratuita o inicia sesión para guardar tu trabajo.",
    "diagramTitle": "Archivo de diagrama"
  },
  "pt": {
    "ai": "AI",
    "language": "Configuração de Língua",
    "file": "Ficheiro",
    "edit": "Editar",
    "select": "Selecionar",
    "insert": "Inserir",
    "arrange": "Layout",
    "view": "Visualização",
    "help": "Ajuda",
    "symbol": "Símbolo",
    "hide": "Esconder",
    "show": "Mostrar",
    "fullScreen": "Ecrã Completo",
    "searchFunc": "Encontrar Característica",
    "themeFunc": "Cor de Tema",
    "saveFile": "Gravar",
    "downloadFile": "Descarregar",
    "outputFile": "Exportar Arquivo",
    "printFile": "Imprimir",
    "shareFile": "Partilhar",
    "encryptFile": "Criptografar",
    "remindMsg": "Ficheiro Partilhado já existe, deseja substituir?",
    "remindMsgExtra": "(O link de compartilhamento mostrará o arquivo mais recente após substituí-lo)",
    "timeout": "Tempo do pedido esgotado, por favor, verificar rede.",
    "autoSaving": "Gravação automática",
    "saving": "Gravação",
    "autoSaved": "Gravado",
    "saveSuccess": "Gravado com Sucesso.",
    "space": "Falha ao gravar, espaço de armazenamento insuficiente. Por favor, eliminar ficheiros Edraw ou limpar a pasta de reciclagem do seu Edraw.",
    "renameFail": "Falha ao renomear, verificar se o nome contém caracteres especiais, como & % $ \\ \/ \" : * ? < > | . 😊, etc.",
    "feedback": "Feedback",
    "sameName": "Já existe um ficheiro com o mesmo nome. Por favor renomear o ficheiro.",
    "noEmpty": "Nome do ficheiro não pode estar vazio.",
    "present": "Apresentação",
    "pagePresent": "Apresentar páginas",
    "presentTip": "Iniciar apresentação de páginas ou apresentação personalizada.",
    "tip": "Dicas Edraw",
    "saveTip": "O documento foi alterado. Deseja gravar agora?",
    "confirm": "OK",
    "cancel": "Cancelar",
    "vip": "Fazer upgrade para Versão Premium",
    "publishWork": "Publicar",
    "vipTips": "<b> Membros do upgrade </b> podem usar formas e documentos ilimitados e oferecer suporte ao uso simultâneo de desktop edrawmax! \"",
    "editShared": "O documento é compartilhado!",
    "lockedFile": "O arquivo está criptografado, descriptografe-o antes de compartilhar",
    "startEdit": "Comece a editar",
    "groupRemind": "Existem atualmente usuários editando",

    "output": "Exportar",
    "return": "Retorna",
    "collect": "Coletar",
    "comment": "Comentário",
    "publishToStore": "Publicar",
    "nologinTips": "Suas edições não são salvas. Crie uma conta gratuita ou faça login para salvar seu trabalho.",
    "diagramTitle": "Arquivo de diagrama"
  },
  "it": {
    "ai": "AI",
    "language": "Impostazioni Lingua",
    "file": "File",
    "edit": "Modifica",
    "select": "Selezionare",
    "insert": "Inserisci",
    "arrange": "Layout",
    "view": "Vista",
    "help": "Aiuto",
    "symbol": "Simboli",
    "hide": "Nascondi",
    "show": "Mostra",
    "fullScreen": "Schermo Intero",
    "searchFunc": "Trova Funzioni",
    "themeFunc": "Colore del tema",
    "saveFile": "Salva",
    "downloadFile": "Scarica",
    "outputFile": "Esporta file",
    "printFile": "Stampa",
    "shareFile": "Condividi",
    "encryptFile": "Crittografare",
    "remindMsg": "Il file condiviso è già esistente. Desideri sostituirlo?",
    "remindMsgExtra": "(Il link di condivisione corrente mostrerà l'ultimo file dopo averlo sovrascritto)",
    "timeout": "Il tempo per inviare la richiesta è scaduto. Si prega di controllare la connessione di rete.",
    "autoSaving": "Salvataggio Automatico",
    "saving": "Salvataggio in Corso",
    "autoSaved": "Salvato",
    "saveSuccess": "Salvataggio avvenuto con successo.",
    "space": "Salvataggio fallito. Non c'è spazio a sufficienza. Si prega di eliminare file di Edraw o di svuotare il cestino di Edraw.",
    "renameFail": "Rinominazione fallita. Assicurarsi che il nome non contenga caratteri speciali, quali & % $ \\ \/ \" : * ? < > | . 😊, ecc.",
    "feedback": "Feedback",
    "sameName": "Esiste già un file con questo nome. Si prega di sceglierne un altro.",
    "noEmpty": "Si prega di compilare il campo del nome.",
    "present": "Presentazione",
    "pagePresent": "Presentazione Pagine",
    "presentTip": "Avvia la presentazione delle pagine o una presentazione personalizzata.",
    "tip": "Suggerimenti di Edraw",
    "saveTip": "Il documento è stato modificato. Desideri salvarlo?",
    "confirm": "OK",
    "cancel": "Annulla",
    "vip": "Esegui l'Upgrade alla Versione Premium",
    "publishWork": "发布",
    "vipTips": "I <b> membri dell'aggiornamento </b> possono utilizzare moduli e documenti illimitati e supportare l'uso simultaneo di Edrawmax desktop!",
    "editShared": "Il documento è condiviso!",
    "lockedFile": "Il file è crittografato, decrittalo prima di condividerlo",
    "startEdit": "Inizia a modificare",
    "groupRemind": "Attualmente ci sono utenti che stanno modificando",

    "output": "Esporta",
    "return": "ritorno",
    "collect": "Preferiti",
    "comment": "Commento",
    "publishToStore": "Pubblicare",
    "nologinTips": "Le tue modifiche non vengono salvate. Crea un account gratuito o accedi per salvare il tuo lavoro.",
    "diagramTitle": "File di diagramma"
  },
  "tw": {
    "ai": "AI",
    "language": "語言設置",
    "file": "檔案",
    "edit": "編輯",
    "select": "選擇",
    "insert": "插入",
    "arrange": "佈局",
    "view": "視圖",
    "help": "幫助",
    "symbol": "形狀",
    "hide": "隱藏",
    "show": "顯示",
    "fullScreen": "全屏視圖",
    "searchFunc": "功能查找",
    "themeFunc": "主題色",
    "saveFile": "儲存檔案",
    "downloadFile": "下載檔案",
    "outputFile": "導出檔案",
    "printFile": "打印檔案",
    "shareFile": "分享檔案",
    "encryptFile": "檔案加密",
    "remindMsg": "分享檔案已存在，是否覆蓋？",
    "remindMsgExtra": "（覆蓋後當前的分享連結將會顯示最新的檔案）",
    "timeout": "請求超時，請檢查網絡",
    "autoSaving": "自動儲存中...",
    "saving": "儲存中...",
    "autoSaved": "儲存完成",
    "saveSuccess": "儲存成功",
    "space": "儲存失敗，雲端硬碟已達上限， 刪除檔案或清理回收站",
    "renameFail": "重命名失敗，名字不能包含特殊字符(& % $ \\ \/ \" : * ? < > | . 😊等)",
    "feedback": "反饋中心",
    "sameName": "已存在同名檔案，請重新命名",
    "noEmpty": "檔案名不能為空！",
    "present": "演示",
    "pagePresent": "頁面演示",
    "presentTip": "開始頁面演示或自定義演示。",
    "tip": "Edraw 提醒",
    "saveTip": "檔案有改動尚未儲存，是否現在儲存？",
    "confirm": "確認",
    "cancel": "取消",
    "vip": "升級VIP會員",
    "publishWork": "發佈",
    "vipTips": "<b>升級會員</b> 即可使用無限的形狀及檔案，並支持同時使用桌面端億圖圖示！",
    "editShared": "檔案已分享，請勿重複分享",
    "lockedFile": "檔案已加密，請解密後再分享檔案",
    "startEdit": "開始編輯",
    "groupRemind": "當前已有用戶正在編輯",
    "guideBoxTitle": "要同時發表作品到社區嗎？",
    "guideBoxContent": "發表作品不僅可以分享知識，還可以賺錢哦~（月收益最高可達千元）",
    "guideBoxConfirm": "我知道了",
    "share": "分享",
    "publish": "發表",
    
    "output": "導出",
    "return": "返回",
    "collect": "收藏",
    "comment": "評論",
    "publishToStore": "發佈",
    "nologinTips": "您的編輯並未儲存。建立免費帳戶或登入以儲存您的作品。",
    "diagramTitle": "圖表檔案"
  },
  "kr": {
    "ai": "AI",
    "language": "언어 설정",
    "file": "파일",
    "edit": "편집",
    "select": "선택",
    "insert": "삽입",
    "arrange": "배치",
    "view": "보기",
    "help": "도움",
    "symbol": "모양",
    "hide": "숨기",
    "show": "보여주기",
    "fullScreen": "전체 화면 보기",
    "searchFunc": "기능 찾기",
    "themeFunc": "테마색",
    "saveFile": "파일 저장",
    "downloadFile": "파일 다운로드",
    "outputFile": "파일 내보내기",
    "printFile": "파일 인쇄",
    "shareFile": "파일 공유 ",
    "encryptFile": "문서 암호화",
    "remindMsg": "공유 파일이 이미 있습니다. 바꾸시겠습니까?",
    "remindMsgExtra": "(공유 링크를 덮어쓰면 최신 파일이 표시됩니다.)",
    "timeout": "요청 시간 초과입니다. 네트워크를 확인하십시오.",
    "autoSaving": "자동 저장중...",
    "saving": "저장중...",
    "autoSaved": "저장됨",
    "saveSuccess": "저장 성공",
    "space": "저장에 실패했습니다. 저장 공간이 부족합니다. Edraw 파일을 삭제하거나 휴지통을 청소하십시오.",
    "renameFail": "이름을 바꾸지 못했습니다. 이름에 & % $ \\ \/ \" : * ? < > | . 😊 등과 같은 특수 문자가 포함되어 있는지 확인하십시오.",
    "feedback": "피드백 센터",
    "sameName": "같은 이름의 파일이 이미 있습니다. 이름을 바꾸십시오.",
    "noEmpty": "파일 이름은 비워 둘 수 없습니다.",
    "present": "프리젠테이션",
    "pagePresent": "페이지 프리젠테이션",
    "presentTip": "페이지 프리젠테이션 또는 사용자 지정 프리젠테이션 시작",
    "tip": "Edraw 팁",
    "saveTip": "문서가 변경되었습니다. 지금 저장하시겠습니까?",
    "confirm": "확인 ",
    "cancel": "취소",
    "vip": "VIP 멤버십 업그레이드",
    "publishWork": "게시",
    "vipTips": "<b>업그레이드 멤버</b>는 도형과 문서를 무제한으로 사용할 수 있으며, 데스크톱 Edrawmax를 동시에 사용할 수 있습니다!",
    "editShared": "문서가 공유되었습니다!",
    "lockedFile": "파일이 암호화되어 있습니다. 공유하기 전에 암호를 해독하십시오.",
    "startEdit": "편집 시작",
    "groupRemind": "현재 편집 중인 사용자가 있습니다.",
    "guideBoxTitle": "템플릿 커뮤니티에 파일을 게시하시겠습니까?",
    "guideBoxContent": "지식을 공유하고 수익을 올리려면 파일을 템플릿 커뮤니티에 게시하십시오. (월수입은 최대 20만까지 가능)",
    "guideBoxConfirm": "확인",
    "share": "공유",
    "publish": "게시",

    "output": "내보내기",
    "return": "돌아가기",
    "collect": "즐겨찾기",
    "comment": "댓글",
    "publishToStore": "게시",
    "nologinTips": "편집 내용이 저장되지 않았습니다. 무료 계정을 만들거나 로그인하여 작업을 저장하세요.",
    "diagramTitle": "다이어그램 파일"
  }
}
</i18n>
<template>
    <div v-show="expandTop">
        <component :is="'appLimitFileModal'" v-if="showAppLimitFileModal" @closeModal="closeModal" @continueCreate="continueCreate" />
        <div class="tabs" draggable="false">
            <template v-if="isPlugin">
                <template v-if="isPreviewView">
                    <div class="group-tab">
                        <div class="group-left">
                            <div class="work-return" @click="back2Board">
                                <iconSymbol name="topbar-back" />
                            </div>
                        </div>
                        <div class="group-right">
                            <div class="board-edit" v-if="isPreviewView" @click="startPluginEdit()">
                                <span>{{ $t("startEdit") }}</span>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="tabs-layer tabs-board" draggable="false">
                        <div class="tabs-left">
                            <div class="tabs-main" id="topMenuBtn">
                                <div class="tabs-menu" @click.stop="toBoardHome">新建</div>
                                <div
                                    class="tabs-menu"
                                    v-if="!isPlugin"
                                    @click.stop="activeThis('tabsFile', tabType.file)"
                                    ref="tabsFile"
                                    @mouseenter="showThisDrop($event, tabType.file)"
                                    @mouseleave="clearTabType"
                                    :class="{
                                        activedTab: activeTabType === tabType.file,
                                        activeFunc: activeFunc == 'topMenuFile',
                                    }"
                                >
                                    {{ $t("file") }}
                                </div>
                                <div
                                    class="tabs-menu"
                                    @click.stop="activeThis('tabsEdit', tabType.edit)"
                                    ref="tabsEdit"
                                    @mouseenter="showThisDrop($event, tabType.edit)"
                                    @mouseleave="clearTabType"
                                    :class="{
                                        activedTab: activeTabType === tabType.edit,
                                        activeFunc: activeFunc == 'topMenuEdit',
                                    }"
                                >
                                    {{ $t("edit") }}
                                </div>
                                <div
                                    class="tabs-menu"
                                    @click.stop="activeThis('tabsSelect', tabType.select)"
                                    ref="tabsSelect"
                                    @mouseenter="showThisDrop($event, tabType.select)"
                                    @mouseleave="clearTabType"
                                    :class="{
                                        activedTab: activeTabType === tabType.select,
                                        activeFunc: activeFunc == 'topMenuSelect',
                                    }"
                                >
                                    {{ $t("select") }}
                                </div>
                                <div
                                    class="tabs-menu"
                                    @click.stop="activeThis('tabsInsert', tabType.insert)"
                                    ref="tabsInsert"
                                    @mouseenter="showThisDrop($event, tabType.insert)"
                                    @mouseleave="clearTabType"
                                    :class="{
                                        activedTab: activeTabType === tabType.insert,
                                        activeFunc: activeFunc == 'topMenuInsert',
                                    }"
                                >
                                    {{ $t("insert") }}
                                </div>
                                <div
                                    class="tabs-menu"
                                    @click.stop="activeThis('tabsArrange', tabType.arrange)"
                                    ref="tabsArrange"
                                    @mouseenter="showThisDrop($event, tabType.arrange)"
                                    @mouseleave="clearTabType"
                                    :class="{
                                        activedTab: activeTabType === tabType.arrange,
                                        activeFunc: activeFunc == 'topMenuArrange',
                                    }"
                                >
                                    {{ $t("arrange") }}
                                </div>
                                <div
                                    class="tabs-menu"
                                    @click.stop="activeThis('tabsView', tabType.view)"
                                    ref="tabsView"
                                    @mouseenter="showThisDrop($event, tabType.view)"
                                    @mouseleave="clearTabType"
                                    :class="{
                                        activedTab: activeTabType === tabType.view,
                                        activeFunc: activeFunc == 'topMenuView',
                                    }"
                                >
                                    {{ $t("view") }}
                                </div>
                                <div
                                    class="tabs-menu"
                                    @click.stop="activeThis('tabsSymbol', tabType.symbol)"
                                    ref="tabsSymbol"
                                    @mouseenter="showThisDrop($event, tabType.symbol)"
                                    @mouseleave="clearTabType"
                                    :class="{
                                        activedTab: activeTabType === tabType.symbol,
                                        activeFunc: activeFunc == 'topMenuSymbol',
                                    }"
                                >
                                    {{ $t("symbol") }}
                                </div>
                                <!-- 开发环境保留帮助下拉菜单 -->
                                <div
                                    v-if="!isBuild"
                                    class="tabs-menu"
                                    @click.stop="activeThis('tabsHelp', tabType.help)"
                                    ref="tabsHelp"
                                    @mouseenter="showThisDrop($event, tabType.help)"
                                    @mouseleave="clearTabType"
                                    :class="{ activedTab: activeTabType === tabType.help }"
                                >
                                    {{ $t("help") }}
                                </div>
                                <div v-if="false" class="tabs-menu" @click="toSearch()" @mouseenter="closeMenuDrop">{{ $t("searchFunc") }}</div>
                                <!-- <div class="tabs-icon" v-if="false" :content="$t('searchFunc')" v-tippy="{ placement : 'bottom-start' }">
                                    <iconSymbol style="fill: #424242;stroke: #424242" :name="'searchFunc'" @click.native='toSearch()'/>
                                </div> -->
                            </div>
                        </div>
                        <div class="tabs-board-btn" @click="saveToBoard" :content="'完成编辑并保存'" v-tippy="{ placement: 'bottom' }">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="6.5" y="3.5" width="5" height="4" stroke="white" stroke-linejoin="round" />
                                <rect x="6.5" y="10.5" width="7" height="6" stroke="white" stroke-linejoin="round" />
                                <path
                                    d="M3.5 4C3.5 3.72386 3.72386 3.5 4 3.5H13.0858C13.2184 3.5 13.3456 3.55268 13.4393 3.64645L16.3536 6.56066L16.7071 6.20711L16.3536 6.56066C16.4473 6.65443 16.5 6.7816 16.5 6.91421V16C16.5 16.2761 16.2761 16.5 16 16.5H4C3.72386 16.5 3.5 16.2761 3.5 16V4Z"
                                    stroke="white"
                                    stroke-linejoin="round"
                                />
                            </svg>
                            保存文件
                        </div>
                    </div>
                    <div class="tabs-container">
                        <Navigation></Navigation>
                    </div>
                </template>
            </template>
            <template v-else-if="!isPreviewView">
                <div class="tab-tool">
                    <div class="tool-left">
                        <div class="tabs-topbar" draggable="false">
                            <div class="tabs-left">
                                <div class="tabs-icon" :content="$t('return')" v-tippy="{ placement: 'bottom' }">
                                    <div class="home-logo svg-box" @click="toHome('clickLogo')" id="back2home">
                                        <Icon v-if="EDCONFIG.IS_SDK" type="ios-arrow-back" size="24" />
                                        <template v-else>
                                            <img :src="require('@/app/assets/topPanel/logo.svg')" alt="" />
                                            <div class="step-wrapper"></div>
                                        </template>
                                    </div>
                                </div>
                                <div class="logo-line"></div>

                                <div
                                    class="top-menus svg-box"
                                    @click.stop="handleShowAllDrop"
                                    ref="tabsAll"
                                    :class="{
                                        'top-menu-active': showAllDrop,
                                    }"
                                >
                                    <iconSymbol name="top-menu" class="item-icon menu-icon" />
                                    <AllDrop
                                        ref="allDrop"
                                        class="main-drops menu-container"
                                        v-show="showAllDrop"
                                        :showAllDrop="showAllDrop"
                                        style="padding-top: 6px; padding-bottom: 6px; margin-left: -5px"
                                        v-click-outside="closeAllDrop"
                                        @closeDrop="closeAllDrop"
                                    />
                                </div>

                                <div
                                    class="reName-box"
                                    v-if="!isPreviewView"
                                    @click="
                                        () => {
                                            this.$track('fastTool', 'rename', 'double click');
                                        }
                                    "
                                >
                                    <div class="tabs-icon save-icon" :content="$t('saveFile')" v-tippy="{ placement: 'bottom' }">
                                        <div class="svg-box save-svg" @click.stop="toSave" :class="{ activeFunc: activeFunc == 'menuSaveFile' }">
                                            <iconSymbol class="item-icon" name="save-file" />
                                        </div>
                                    </div>

                                    <p v-if="noLoginEditor" class="work-title">
                                        <span v-if="seoLinkFileName" :title="seoLinkFileName">{{ seoLinkFileName }}</span>
                                        <span v-else>{{ $t("diagramTitle") }}</span>
                                    </p>
                                    <ClickEdit
                                        v-else-if="!isShareEditFile"
                                        ref="clickEdit"
                                        class="reName"
                                        :text="fileName"
                                        :eventName="'click'"
                                        @editOK="rename($event)"
                                    />
                                    <p v-else class="work-title" :title="fileName">{{ fileName }}</p>
                                    <div
                                        class="svg-box star-svg"
                                        v-if="!noLoginEditor && !otherTypeFile && edconfigCollectEnable"
                                        @click.stop="setStar"
                                        :content="$t('collect')"
                                        v-tippy="{ placement: 'bottom' }"
                                    >
                                        <iconSymbol
                                            name="top-star"
                                            class="item-icon star-icon"
                                            :class="{
                                                'item-star-active': fileStar == 1,
                                                activeFunc: activeFunc == 'menuStarFile',
                                            }"
                                        />
                                    </div>
                                    <p class="tabs-saveTips" v-text="saveTips"></p>
                                    <div class="save-loading" v-if="saveState > 0">
                                        <div class="loadingio-spinner-rolling-ffv2b7h2vv6">
                                            <div class="ldio-vl3uzqovzc">
                                                <div></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="groupView-namebox" v-else>
                                    <div>
                                        <p>{{ fileName }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="!noLoginEditor" class="tool-right" draggable="false">
                        <div class="tabs-right" :class="{ 'tabs-right-fit': !internal && lang == 'en' }" draggable="false">
                            <!-- en promodal -->
                            <template>
                                <div class="change-theme" @click="changeTheme" v-if="isDev">切换主题</div>
                                <HelpMenu class="tabpanel-helpbtn" ref="helpMenu" :userInfo="userInfo" :from="'app'" v-if="!EDCONFIG.IS_SDK" />
                                <div
                                    class="play-icon right-icon"
                                    @click="toShowPageSlider(0, 'toolbar')"
                                    :content="$t('present')"
                                    v-tippy="{ placement: 'bottom' }"
                                    @mouseenter="handleShowPlaySliderDrop"
                                    @mouseleave="playSliderVisible = false"
                                >
                                    <iconSymbol name="play-pdf" />
                                    <div v-show="playSliderVisible" class="main-drops menu-container">
                                        <PlaySliderDrops
                                            @closeDrop="() => (playSliderVisible = false)"
                                            @playFromHead="toShowPageSlider(0, 'list_from_beginning-hove')"
                                            @playFromCurrent="toShowPageSlider(activedPageIndex, 'list_from_current-hover')"
                                        />
                                    </div>
                                </div>

                                <div class="export-line line"></div>
                                <div class="btn-wrapper" @mouseenter="hoverVipPopover" v-if="EDCONFIG.TAB_PANEL_UPGRADE_BTN_ENABLE">
                                    <div
                                        class="vip-btn2"
                                        id="vip-btn"
                                        v-if="!(vipState || isPrivate || isTeamsApp)"
                                        @click="!internal && lang == 'en' ? toVip2() : toVip()"
                                    >
                                        <img :src="require(`@/home/assets/img/topbar-vip2.svg`)" alt="" />
                                        <span id="topbar-buybox_word" :title="$t('vip')">{{ $t("vip") }}</span>
                                    </div>
                                    <div class="vip-popover" ref="vipPopover" :class="{ 'used-vip': vipPopoverName == 'VipPopover' }">
                                        <component :is="vipPopoverName" @toVip="!internal && lang == 'en' ? toVip2() : toVip()" />
                                    </div>
                                </div>
                            </template>

                            <div class="export-btn" ref="exportBtn" @click="(e) => clickExport(e)" v-click-outside="closeExport">
                                <div class="btn-box" :class="{ 'btn-box__no-margin-right': !EDCONFIG.SHARE_ENABLE }">
                                    <iconSymbol name="top-export" />
                                    <span>{{ $t("output") }}</span>
                                </div>
                                <div v-if="exportDropVisible" class="main-drops menu-container">
                                    <ExportDrop @closeExportDrop="() => (exportDropVisible = false)" />
                                </div>
                            </div>

                            <template v-if="!EDCONFIG.IS_SDK || EDCONFIG.SHARE_ENABLE">
                                <div
                                    id="tabpanel-btnbox"
                                    class="publish-share-btn"
                                    :class="publishBtnVisible ? '' : 'no-publish'"
                                    v-if="!(!publishBtnVisible && !(!isTeamFile && !isInclowdz && !isTeamsApp))"
                                >
                                    <div class="btn-left btn" @click="toShare()">
                                        {{ $t("share") }}
                                    </div>
                                    <div
                                        class="btn-right btn"
                                        @click="showPublishBtn = !showPublishBtn"
                                        v-click-outside="hidePublish"
                                        v-if="publishBtnVisible"
                                    >
                                        <iconSymbol name="top-arrow-down" />
                                    </div>
                                    <div class="publish-btn" v-if="showPublishBtn" @click="handleClickPublish()">
                                        {{ $t("publishToStore") }}
                                    </div>
                                    <div class="step-wrapper" v-if="!EDCONFIG.IS_SDK"></div>
                                </div>
                            </template>

                            <div class="user-line line"></div>

                            <div v-if="EDCONFIG.IS_SDK" :style="{ width: vipState ? '50px' : '182px' }"></div>
                            <template v-else>
                                <UserMenu
                                    v-if="!isInclowdz"
                                    class="tabpanel-userbtn"
                                    :userInfo="userInfo"
                                    :vipState="vip"
                                    :from="'app'"
                                    :showCloud="false"
                                />
                            </template>
                        </div>
                    </div>

                    <div v-if="isEdit && noLoginEditor && !EDCONFIG.IS_SDK" class="tool-edit">
                        <p>{{ $t("nologinTips") }}</p>
                        <div class="tabs-icon-btn" @click="nologinSave">
                            {{ $t("saveFile") }}
                        </div>
                    </div>
                </div>

                <div class="tabs-container">
                    <Navigation></Navigation>
                </div>
            </template>

            <template v-else>
                <div class="group-tab">
                    <div class="group-left">
                        <div class="work-return" v-if="!isWorkwx" @click="toHome">
                            <iconSymbol name="topbar-back" />
                        </div>
                        <div class="work-return" v-else></div>
                        <p class="work-title" :title="fileName">{{ fileName }}</p>
                    </div>
                    <div class="group-right">
                        <div class="topbar-buybox" v-if="!(vipState || isPrivate || isTeamsApp)" @click="toVip">
                            <p id="topbar-buybox_word" class="vip-btn" :title="$t('vip')">{{ $t("vip") }}</p>
                        </div>

                        <div class="groupView-edit" v-if="isPreviewView && groupRole >= 2" @click="refreshAndStart()">
                            <span>{{ $t("startEdit") }}</span>
                        </div>
                        <template v-if="!isGroupView">
                            <div style="position: relative; height: 32px; line-height: 28px" v-if="!otherTypeFile && !isPrivate && !isTeamsApp">
                                <div class="publish-btn" @click="handleClickPublish()">
                                    <iconSymbol :name="'publishIcon'" />
                                    <span>{{ $t("publish") }}</span>
                                </div>
                            </div>

                            <div
                                class="share-btn"
                                :class="{ activeFunc: activeFunc == 'menuShareFile' }"
                                v-if="!isTeamFile && !isInclowdz && !isTeamsApp"
                                @click="toShare()"
                            >
                                <iconSymbol :name="'shareFile'" />
                                <span>{{ $t("share") }}</span>
                            </div>
                        </template>

                        <UserMenu class="groupView-userbtn" :userInfo="userInfo" :vipState="vip" :from="'app'" :showCloud="false" />
                    </div>
                </div>
            </template>

            <div class="groupLock-modal" v-if="showGroupLockModal">
                <div class="groupLock-box">
                    <div class="groupLock-user">
                        <img v-if="groupLockIcon" :src="groupLockIcon" alt="" />
                        <div class="no-icon" v-else>{{ getFirstName(groupLockInfo) }}</div>
                        <p>{{ groupLockInfo ? groupLockInfo.nick_name : "" }}</p>
                    </div>
                    <div class="groupLock-remind">
                        <p>{{ $t("groupRemind") }}</p>
                    </div>
                    <div class="dialog-btnbox-normal groupLock-btnbox">
                        <div class="dialog-btn-ok" @click="groupModalConfirm()">{{ $t("confirm") }}</div>
                    </div>
                </div>
            </div>
            <EDShepherd />
            <EDHelpVideo />
        </div>
    </div>
</template>

<script lang="ts">
    declare var saveAs: any;
    declare var egSize: any;
    declare var AutoSaveTimer;
    declare var EDDocument: any;
    declare var $edAuth: any;
    enum tabType {
        file,
        edit,
        select,
        insert,
        arrange,
        view,
        help,
        symbol,
        ai,
        plugin,
    }
    import appConfig from "@/public/globalConfig";
    import Navigation from "./Tabs/Navigation.vue";
    import axios from "axios";
    // import Home from "./Tabs/Home.vue";
    // import Insert from "./Tabs/Insert.vue";
    // import Layout from "./Tabs/Layout.vue";
    // import Views from "./Tabs/View.vue";
    import { Component, Prop, Vue, Watch, Inject } from "vue-property-decorator";
    import table from "../store/modules/table";
    import ClickEdit from "./Common/ClickEdit.vue";
    import DownloadMenu from "./DropMenus/expandMenus/DownloadMenus.vue";
    import CryptMenu from "./DropMenus/expandMenus/CryptMenus.vue";
    import ThemeDrops from "./DropMenus/ThemeDrops.vue";
    import Ws from "@/public/utils/ws";
    import EDShepherd from "./EDShepherd.vue";
    import EDHelpVideo from "./EDHelpVideo.vue";
    import HelpMenu from "@/public/components/helpmenu/helpmenu.vue";
    import UserMenu from "@/public/components/userMenu/userMenu.vue";
    import AllDrop from "./DropMenus/AllDrop.vue";
    import ExportDrop from "./DropMenus/ExportDrops.vue";
    import PlaySliderDrops from "./DropMenus/PlaySliderDrops.vue";
    import { getHashString, getSdkSaveData } from "@/public/utils/tool";
    import { ValidLang } from "../utils/constant";
    import NoVipPopover from "./Modals/NoVipPopover.vue";
    import VipPopover from "./Modals/VipPopover.vue";

    @Component({
        components: {
            Navigation,
            ClickEdit,
            DownloadMenu,
            CryptMenu,
            ThemeDrops,
            EDShepherd,
            EDHelpVideo,
            HelpMenu,
            UserMenu,
            AllDrop,
            ExportDrop,
            PlaySliderDrops,
            NoVipPopover,
            VipPopover,
            appLimitFileModal: () => import("./appLimitFileModal.vue"),
        },
    })
    export default class TabPanel extends Vue {
        @Inject()
        ["showMessage"];
        @Inject()
        ["checkVipLimit"];
        isBuild = appConfig.isBuild;
        buildLang = appConfig.language;
        tabType = tabType;
        fileName: string = "新建文件名";
        blockClick: boolean = false;
        shareTimer = null;
        shareCancel = null;
        saveTips: any = "";
        showOutputDrop: boolean = false;
        showEncryptDrop: boolean = false;
        showThemeDrop: boolean = false;
        upgradeVip: number = 0;
        msgFrom: string = "click";
        showGuideToPublish: boolean = false;
        // group
        showGroupLockModal: boolean = false;
        showPublishBtn: boolean = false;

        showAppLimitFileModal = false;
        closeModal() {
            this.showAppLimitFileModal = false;
        }
        continueCreate() {
            this.showAppLimitFileModal = false;
            this.createFileAndRedirect();
        }

        setStar() {
            if (window.EDCONFIG.IS_SDK) {
                const type = this.fileStar ^ 1;
                this.sdkApp.promisePostMessage("POST_COLLECT", { type }).then(() => {
                    this.fileStar = type;
                    this.$emit("closeDrop");
                });
                return;
            }

            if (this.noLoginEditor) {
                this.nologinSave();
                return;
            }
            this.sensors.track("clickEditPageButton", {
                Catalogues: "editPageButton",
                button_type: "clickStar",
            });
            let type = this.fileStar ^ 1;
            let params = {
                id: this.userInfo.user_id,
                token: this.userInfo.token,
                start_tag: type,
                obj_id: this.fileID,
            };
            let getPath = () => {
                let ts: any = this;
                let filePath = ts.$unZipFileName(window.location.search.substr(1)).substring(4);
                let path = "",
                    pathArr = filePath.split("/");
                pathArr.shift();
                pathArr.shift();
                pathArr.pop();
                if (pathArr.length > 0) {
                    path = pathArr.join("/") + "/";
                }
                return path;
            };
            if (this.isPrivate) {
                Object.assign(params, {
                    file_key: this.$store.getters.fileKey,
                });
            }
            this.$edApi.setStar(params).then((res) => {
                window.opener &&
                    window.opener.postMessage(
                        {
                            type: "updateMyfile",
                            updateStarFile: true,
                        },
                        location.origin
                    );
                window.opener &&
                    window.opener.postMessage(
                        {
                            type: "updateCloudFileStar",
                            fileID: this.fileID,
                            path: getPath(),
                            status: type,
                        },
                        location.origin
                    );
                this.fileStar = type;
            });
            this.$emit("closeDrop");
        }

        get isDev() {
            return process.env.NODE_ENV === "development";
        }

        changeTheme() {
            let newDarkMode = !this.darkMode;
            this.$store.commit("setStatus", {
                type: "darkMode",
                data: !this.darkMode,
            });
            const html = document.querySelector("html");
            let themeColor = "#017fff";
            let themeHover = "#0177f0";

            if (newDarkMode) {
                html.classList.add("dark");
                themeColor = "#7755ff";
                themeHover = "#8f6cff";
            } else {
                html.classList.remove("dark");
            }
            document.body.style.setProperty("--themeColor", themeColor);
            document.body.style.setProperty("--themeHover", themeHover);
        }
        getFirstName(item) {
            return item ? item.nick_name.trim().split("")[0] : "";
        }

        get activedPageIndex() {
            return this.$store.state.page.activedPageIndex;
        }

        get darkMode() {
            return this.$store.state.ui.darkMode;
        }

        get isShareEditFile() {
            return this.$store.state.ui.isShareEditFile;
        }

        get isFocusMode() {
            return this.$store.state.ui.isFocusMode;
        }
        get otherTypeFile() {
            // 群组文件和分享可编辑文件
            return this.$store.state.ui.isTeamFile || this.$store.state.ui.isShareEditFile;
        }
        get fileID() {
            return this.$store.state.ui.fileID;
        }
        get fileStar() {
            return this.$store.state.ui.fileStar;
        }
        set fileStar(v) {
            this.$store.commit("setStatus", {
                type: "fileStar",
                data: v,
            });
        }

        get vipState() {
            if (this.isPC) {
                return this.$store.state.pcVip;
            } else {
                return this.$store.state.publicStore.vip;
            }
        }
        get logoIcon() {
            let lang = this.internal ? "zh" : "en";
            return require(`@/home/assets/img/logo-icon-${lang}.png`);
        }
        get isGroupView() {
            return this.$store.state.ui.isGroupView;
        }
        get isPreviewView() {
            return this.$store.state.ui.isPreviewView;
        }
        get isGroupLock() {
            return this.$store.state.ui.isGroupLock;
        }
        get groupRole() {
            return this.$store.state.ui.groupRole;
        }
        get groupLockInfo() {
            return this.$store.state.ui.groupLockInfo;
        }
        get groupLockIcon() {
            if (this.groupLockInfo && this.groupLockInfo.avatar_url) {
                return this.groupLockInfo.avatar_url;
            } else {
                return false;
                // return require('@/home/assets/img/user/slide/icon.png')
            }
        }
        get isTeamFile() {
            return this.$store.state.ui.isTeamFile;
        }
        get saveState() {
            return this.$store.state.ui.saveState;
        }

        get seoLinkFileName() {
            return this.$store.state.ui.seoLinkFileName;
        }

        get oldEdViewLibrarys() {
            return this.$store.state.library.edViewLibrarys;
        }
        set saveState(v) {
            this.$store.commit("setStatus", {
                type: "saveState",
                data: v,
            });
        }
        @Watch("saveState")
        saveStateChanged(v) {
            if (v === 0) {
                let ts = this;
                this.saveTips = this.$t("autoSaved");
                setTimeout(() => {
                    ts.saveTips = "";
                }, 2000);
            } else if (v === 1) {
                this.saveTips = this.$t("autoSaving");
            } else if (v === 2) {
                this.saveTips = this.$t("saving");
            } else {
                this.saveTips = "";
            }
        }

        get isRemarkView() {
            return this.$store.state.ui.isRemarkView;
        }
        set isRemarkView(v) {
            this.$store.commit("setStatus", {
                type: "isRemarkView",
                data: v,
            });
        }

        get shareOption() {
            return this.$store.state.ui.shareOption;
        }
        get shareUUID() {
            return this.$store.state.ui.shareUUID;
        }

        get edconfigCollectEnable() {
            return window.EDCONFIG?.COLLECT_ENABLE !== false;
        }

        showPageSlide = false;
        // axios: any = axios.create({
        //     baseURL: ,
        //     timeout: 50000
        // });
        async checkVerified() {
            // 检测是否实名
            if (!this.internal) {
                return Promise.resolve(true);
            }
            const result = await this.$edApi
                .checkShareVerified({
                    id: this.userInfo.user_id,
                    token: this.userInfo.token,
                })
                .then((e) => {
                    return e.data;
                });
            return result;
        }

        toPromotion() {
            let url = "https://www.edrawsoft.cn/order/buy-double-11-2020.html";
            let newTab = window.open("about:blank");
            newTab.location.href = url;
        }
        handleClickPublish() {
            if (this.checkVipLimit("publishFile")) {
                return;
            }
            this.sensors.track("publishToCommunity", {
                Catalogues: "toptoolbar",
            });
            // 用户未绑定手机
            this.checkVerified().then((isBind) => {
                if (!isBind) {
                    this.$store.commit("toShowPhoneDialog", { fromBtn: "publishBtn" });
                } else {
                    this.toShowPublish();
                }
            });
        }
        toShowPublish() {
            this.$track("publish", "clickpublish", `encryption: ${this.isEncrypt ? "yes" : "no"}`);
            this.sensors.track("startPublish", {
                Catalogues: "publish template",
            });
            this.setPublishStorageStatus();
            if (this.isEncrypt) {
                this.$edMessage.error(this.$t("lockedFile"));
                return;
            }

            this.$store.commit("setStatus", {
                type: "showPublish",
                data: true,
            });
        }
        toFullScreen() {
            this.$track("fastTool", "fullScreen");
            if (document.fullscreenElement || (<any>document).webkitFullscreenElement || (<any>document).msFullscreenElement) {
                this.toCompatExitFullScreen();
            } else {
                this.toCompatFullScreen(document.documentElement);
            }
        }
        toCompatFullScreen(rootEle) {
            if (rootEle.requestFullscreen) {
                rootEle.requestFullscreen();
            } else if (rootEle.webkitRequestFullscreen) {
                rootEle.webkitRequestFullscreen();
            } else if (rootEle.mozRequestFullScreen) {
                rootEle.mozRequestFullScreen();
            } else if (rootEle.msRequestFullscreen) {
                rootEle.msRequestFullscreen();
            }
        }
        toCompatExitFullScreen() {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if ((<any>document).webkitExitFullscreen) {
                (<any>document).webkitExitFullscreen();
            } else if ((<any>document).mozExitFullScreen) {
                (<any>document).mozExitFullScreen();
            } else if ((<any>document).msExitFullscreen) {
                (<any>document).msExitFullscreen();
            }
        }
        toSearch() {
            this.$track("fastTool", "searchFunc");
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "SearchFunc",
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
        }
        toVip() {
            this.$openBuyPage("buyNowFloatWindow");
        }
        toVip2() {
            this.$store.commit("toPublicStatus", {
                type: "upgradeTrigger",
                data: "clickUpgradeEntry",
            });
            this.$bus.$emit("togglePromodal", true, 0, 1);
        }
        togglePageSlide() {
            this.$track("fastTool", "pageSlide");
            this.showPageSlide = !this.showPageSlide;
        }
        closePageSlider() {
            this.showPageSlide = false;
        }
        editName() {
            (this.$refs.clickEdit as any).startEdit();
        }

        checkBuyAction() {
            // 检查是否购买会员。是则刷新页面
            window.addEventListener("storage", (e) => {
                if (e.key == "buyAction" && e.newValue == "1") {
                    window["_view"]._tool.endEdit();
                    let ts: any = this;
                    if (this.$store.state.user.userInfo) {
                        if (AutoSaveTimer) {
                            (<any>this).$Modal.confirm({
                                title: this.$t("tip"),
                                content: this.$t("saveTip"),
                                okText: this.$t("confirm"),
                                cancelText: this.$t("cancel"),
                                onOk: () => {
                                    this.$root["ui"]
                                        .toSaving(true)
                                        ?.then((res) => {
                                            window.location.reload();
                                            window.localStorage.setItem("buyAction", "0");
                                        })
                                        .catch((err) => {});
                                },
                                onCancel: () => {},
                            });
                        } else {
                            window.location.reload();
                            window.localStorage.setItem("buyAction", "0");
                        }
                    }
                }
            });
        }

        rename(e) {
            if (window.EDCONFIG.IS_SDK) {
                const newName = e.trim();
                const oldName = window["_view"]._doc._fileName;
                return new Promise((resolve, reject) => {
                    this.sdkApp
                        .promisePostMessage("PUT_FILE_NAME", newName)
                        .then(() => {
                            this.fileNameSync = newName;
                            resolve();
                        })
                        .catch(() => {
                            reject(oldName);
                        });
                });
            }

            // 改名
            if (this.isTeamFile) {
                this.renameTeam(e);
                return;
            }
            e = e.trim();
            let oldName = window["_view"]._doc._fileName;
            if (oldName == e || e == "")
                // 名字相同不做改动
                return;
            if (!e) {
                (<any>this).$edMessage.warning(this.$t("noEmpty"));
                (<any>this.$refs.clickEdit).renameFail(this.fileName, "fail");
                return;
            }
            if (e.match(/[\\|\/|\:|\*|\?|\"|\<|\>|\||\&|\%|\$|\.]/)) {
                (<any>this).$edMessage.warning(this.$t("renameFail"));
                (<any>this.$refs.clickEdit).renameFail(this.fileName, "fail");
                return;
            }
            let ts: any = this;
            let prefix: any = this.$store.state.ui.fileInfo;
            prefix = prefix.split("/");
            prefix.pop();
            prefix = prefix.join("/") + "/";
            prefix = prefix.match(/Personal\/(.*)/) ? prefix.match(/Personal\/(.*)/)[1] : "";
            let isSameName = false;
            this.$store
                .dispatch("getFloder", { prefix })
                .then((res) => {
                    res.data.data.files.forEach((file) => {
                        let name = "";
                        if (this.isPrivate) {
                            name = file.info.name;
                        } else {
                            let list = file.key.split("/");
                            name = list[list.length - 1];
                            name = name.match(/(.*)\.eddx/) && name.match(/(.*)\.eddx/)[1];
                        }
                        if (name == e && file.key.match(/.+eddx$/)) {
                            isSameName = true;
                        }
                    });

                    if (!isSameName) {
                        let params = {
                            from: prefix + oldName + ".eddx",
                            id: this.$store.state.user.userInfo.user_id,
                            to: prefix + e + ".eddx",
                            token: this.$store.state.user.userInfo.token,
                        };
                        if (this.isPrivate) {
                            let path = this.$store.state.ui.fileInfo;
                            path = path.split("/").slice(2).join("/");
                            Object.assign(params, {
                                file_key: this.$store.getters.fileKey,
                                from: path,
                                to: path,
                                name: e,
                            });
                        }
                        this.$edApi
                            .moveObj(params)
                            .then((res) => {
                                this.fileNameSync = e;
                                let newUrl = "";
                                if (this.isPrivate) {
                                    let url = this.$unZipFileName(location.search.substr(1, location.search.length));
                                    url = url.replace(/(name\=).[^\&]*/, `$1${e}`);
                                    newUrl = window.location.href.replace(/(.*\/)*(\?[^.]+).*/gi, "$1") + "?" + ts.$zipFileName(url);
                                } else {
                                    let newFileInfo = this.$store.state.ui.fileInfo.replace(/(.*\/)*([^.]+).*/gi, "$1") + e + ".eddx";
                                    this.$store.commit("setStatus", {
                                        type: "fileInfo",
                                        data: newFileInfo,
                                    });
                                    newUrl = window.location.href.replace(/(.*\/)*(\?[^.]+).*/gi, "$1") + "?" + ts.$zipFileName("obj=" + newFileInfo);
                                }
                                let stateObj = history.state;
                                document.title = document.title.replace(/.*-(.*)/, e + " -$1");
                                history.replaceState(stateObj, "", newUrl);
                                if (window.opener) {
                                    window.opener.postMessage(
                                        {
                                            type: "updateFiles",
                                        },
                                        location.origin
                                    );
                                }
                                window.localStorage.setItem("reName", "1");
                            })
                            .catch((err) => {
                                this.fileName = oldName;
                                if (err.data && err.data.to && err.data.to == "The to format is invalid.") {
                                    (<any>this).$edMessage.warning(this.$t("renameFail"));
                                    (<any>this.$refs.clickEdit).renameFail(this.fileName, "fail");
                                }
                                if (err.data && err.data.msg == "data invalid") {
                                    (<any>this).$edMessage.warning(this.$t("renameFail"));
                                    (<any>this.$refs.clickEdit).renameFail(this.fileName, "fail");
                                }
                            });
                    } else {
                        (<any>this).$edMessage.warning(this.$t("sameName"));
                        (<any>this.$refs.clickEdit).renameFail(this.fileName, "isSameName");
                    }
                })
                .catch((err) => {
                    this.fileName = window["_view"]._doc._fileName;
                });
        }
        get editTeamOption() {
            return this.$store.state.ui.editTeamOption;
        }
        getSafeName(name, list) {
            let exit = 0,
                exitExpand = 0,
                exitFlag = true,
                numList = [];
            let p = new RegExp("(?=[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？%])", "g"),
                ruleone = new RegExp("\^" + name.replace(p, "\\") + "\\\(\\\d+\\\)$"),
                ruletwo = new RegExp("\^" + name.replace(p, "\\") + "\\\((\\\d*)");

            for (let v of list) {
                if (exitFlag && v.name == name) {
                    exit = 1;
                    exitFlag = false;
                }
                if (ruleone.test(v.name)) {
                    let tempNum = ~~v.name.match(ruletwo)[1];
                    if (tempNum > 0) {
                        numList.push(tempNum);
                        exitExpand = 1;
                    }
                }
            }

            if (exit == 0) {
                return name;
            } else {
                if (exitExpand != 1) {
                    return `${name}(1)`;
                } else {
                    numList = numList.sort((a, b) => {
                        return a - b;
                    });
                    var k;
                    for (var i = 0, len = numList.length; i < len; i++) {
                        if (i + 1 != numList[i]) {
                            k = i + 1;
                            break;
                        } else {
                            k = numList[len - 1] + 1;
                        }
                    }
                    return `${name}(${k})`;
                }
            }
        }
        renameTeam(e) {
            let ts: any = this;
            let teamFiles = [];
            let oldName = window["_view"]._doc._fileName;
            if (oldName == e || e == "")
                // 名字相同不做改动
                return;
            let getTeamFiles = () => {
                return new Promise((rs, rj) => {
                    this.$edApi
                        .getTeamFiles({
                            id: this.userInfo.user_id,
                            token: this.userInfo.token,
                            teamId: this.editTeamOption[0],
                        })
                        .then((res) => {
                            if (res.data && res.data.files.length > 0) {
                                teamFiles = res.data.files.filter((item) => {
                                    if (this.isPrivate) {
                                        item.name = item.info.name;
                                        return true;
                                    } else if (item.key.match(/.+eddx$/)) {
                                        let list = item.key.split("/");
                                        let name = list[list.length - 1];
                                        name = name.match(/(.*)\.eddx/) && name.match(/(.*)\.eddx/)[1];
                                        item.name = name;
                                        return true;
                                    }
                                    return false;
                                });
                            }
                            rs(null);
                        });
                });
            };
            let renameTeamFiles = () => {
                e = this.getSafeName(e, teamFiles);
                let params = {
                    id: this.userInfo.user_id,
                    token: this.userInfo.token,
                    teamId: this.editTeamOption[0],
                    obj_id: this.editTeamOption[1],
                    to: e.trim() + ".eddx",
                    name: e.trim(),
                    file_key: this.$store.getters.fileKey,
                };
                return new Promise((res, rej) => {
                    this.$edApi
                        .reTeamFileName(params)
                        .then(() => {
                            this.fileName = e;
                            let newUrl = "";
                            if (this.isPrivate) {
                                let url = this.$unZipFileName(location.search.substr(1, location.search.length));
                                url = url.replace(/(name\=).[^\&]*/, `$1${e}`);
                                newUrl = window.location.href.replace(/(.*\/)*(\?[^.]+).*/gi, "$1") + "?" + ts.$zipFileName(url);
                            } else {
                                let newFileInfo = this.$store.state.ui.fileInfo.replace(/(.*\/)*([^.]+).*/gi, "$1") + e + ".eddx";
                                newUrl =
                                    window.location.href.replace(/(.*\/)*(\?[^.]+).*/gi, "$1") +
                                    "?" +
                                    ts.$zipFileName("obj=" + newFileInfo) +
                                    "#editTeam";
                                this.$store.commit("setStatus", {
                                    type: "fileInfo",
                                    data: newFileInfo,
                                });
                            }
                            let stateObj = history.state;
                            document.title = document.title.replace(/.*-(.*)/, e + " -$1");
                            history.replaceState(stateObj, "", newUrl);
                            if (window.opener) {
                                window.opener.postMessage("updateTeamFile", location.origin);
                            }
                            res(null);
                        })
                        .catch((err) => {
                            this.fileName = window["_view"]._doc._fileName;
                        });
                });
            };
            getTeamFiles().then(renameTeamFiles);
        }
        refreshFilename(name: string) {
            this.fileName = name;
        }
        closeMenuDrop() {
            this.$bus.$emit("closeMenuDrop");
        }
        clearTabType() {
            if (this.showDropdown) return;
            this.activeTabType = -1;
        }

        showThisDrop(e: MouseEvent, type: tabType) {
            if (this.activeTabType !== type) {
                if (this.showDropdown) {
                    this.activeTabType = type;
                }
                this.$store.commit("setStatus", {
                    type: "dropType",
                    data: type,
                });
                if (this.showDropdown) {
                    this.setDropsPos(e.target, type);
                }
            }
        }
        activeThis(e: any, type: tabType) {
            let dom: any = this.$refs[e] as HTMLElement;
            window["_view"]._tool.endEdit();
            this.showDropdown = !this.showDropdown;
            this.activeTabType = type;
            this.$store.commit("setStatus", {
                type: "dropType",
                data: type,
            });
            this.$store.commit("setStatus", {
                type: "showContextMenu",
                data: false,
            });

            let domRect = dom.getBoundingClientRect();
            this.$store.commit("setDialogState", {
                type: "targetPosition",
                data: { x: domRect.x, y: domRect.y + domRect.height },
            });
            if (this.showDropdown) {
                this.setDropsPos(dom);
            }
            if (this.showOutputDialog) {
                // 兼容stop冒泡，主动关闭导出栏
                this.closeEvent({ target: null });
            }
        }
        setDropsPos(node, type = -1) {
            let top = 0,
                left = node.offsetWidth + 10;
            do {
                top += node.offsetTop;
                left += node.offsetLeft;
                if (type == 8) {
                    top -= 100;
                }
                node = node.offsetParent;
            } while (node !== null);

            this.$store.commit("setStatus", {
                type: "dropTop",
                data: top,
            });
            this.$store.commit("setStatus", {
                type: "dropLeft",
                data: left,
            });
        }

        hasDifferentElements(arr1, arr2) {
            if (arr1.length !== arr2.length) {
                return true;
            }
            const set = new Set(arr1);
            for (let i = 0; i < arr2.length; i++) {
                if (!set.has(arr2[i])) {
                    return true;
                }
            }
            return false;
        }

        async toSave() {
            if (window.EDCONFIG.IS_SDK) {
                if (this.saveState <= 0 || AutoSaveTimer) {
                    this.saveState = 2;
                }
                const fileData = await getSdkSaveData();
                this.sdkApp
                    .promisePostMessage("PUT_FILE", { file: fileData.file, img: fileData.img, svgImg: fileData.svgImg })
                    .then(() => {
                        this.saveState = 0;
                        this.$edMessage.success(this.$t("saveSuccess"));
                    })
                    .catch(() => {
                        this.saveState = -1;
                    })
                    .finally(() => {
                        if (AutoSaveTimer) {
                            clearTimeout(AutoSaveTimer);
                            AutoSaveTimer = null;
                        }
                    });
                return;
            }
            if (this.noLoginEditor) {
                this.nologinSave();
                return;
            }
            this.$track("fastTool", "save file");
            this.activeFunc = "";
            this.sensors.track("clickEditPageButton", {
                Catalogues: "editPageButton",
                button_type: "clickSave",
            });
            let force = false;
            let newLibrarys = window["_view"]._doc._librarys;
            if (newLibrarys && this.hasDifferentElements(newLibrarys, this.oldEdViewLibrarys)) {
                force = true;
                this.$store.commit("setLibraryState", {
                    type: "edViewLibrarys",
                    data: newLibrarys,
                });
            }
            this.$root["ui"]
                .toSaving(true, force, true, "button")
                ?.then((res) => {
                    this.saveState = 0;
                })
                .catch((err) => {
                    this.saveState = -1;
                });
        }
        toDownload() {
            this.$track("fastTool", "download file");
            let ts: any = this;
            this.activeFunc = "";
            // if (!ts.$checkAuth({type:'download'})) return
            if (this.isInclowdz) {
                this.inclowdzDownload();
                return;
            }
            this.showGuidePublish();
            window["_view"].saveFileToLocal();
        }
        inclowdzDownload() {
            let ts: any = this;
            let obj = ts.$unZipFileName(window.location.search.substr(1)).substr(4);
            let filePath = obj.match(/[^\/]+\/[^\/]+\/(.+)/) && obj.match(/[^\/]+\/[^\/]+\/(.+)/)[1];
            let params = Object.assign(
                { obj: filePath },
                {
                    id: this.userInfo.user_id,
                    token: this.userInfo.token,
                }
            );
            this.$edApi.getDownFileAddress(params).then((res) => {
                let downUrl = `${window["GLOBAL"].PRIVATE_OSS_HOST}${encodeURIComponent(obj)}?${res.data.sign}`;
                let ossParams = {
                    url: obj,
                    exp: res.data.exp,
                    sign: res.data.sign || res.data.query,
                    responseType: "blob",
                };
                this.$edApi.downloadOSSFile(ossParams).then((e) => {
                    window.parent.postMessage(
                        {
                            mode: "iframe2parent",
                            target: "file",
                            action: "export",
                            type: "request",
                            session_id: "0000000003",
                            version: "v1",
                            data: {
                                filename: obj.match(/[^\/]*(?=\.eddx)/i)[0] + ".eddx",
                                filesize: e.data.size,
                                download_url: downUrl,
                            },
                        },
                        "*"
                    );
                });
            });
        }
        get showOutputDialog() {
            return this.$store.state.dialog.showOutputDialog;
        }
        set showOutputDialog(v) {
            this.$store.commit("setDialogState", {
                type: "showOutputDialog",
                data: v,
            });
        }
        get outputDialogPosition() {
            return this.$store.state.dialog.outputDialogPosition;
        }
        set outputDialogPosition(v) {
            this.$store.commit("setDialogState", {
                type: "outputDialogPosition",
                data: v,
            });
        }
        toOutput(e) {
            if (!this.showOutputDialog) {
                this.$track("fastTool", "output file");
                this.activeFunc = "";
                const BOXHEIGHT = 32; // 按钮高度
                this.outputDialogPosition = {
                    left: e.clientX - e.offsetX,
                    top: e.clientY - e.offsetY + BOXHEIGHT,
                };
                this.showOutputDialog = true;
                this.sensors.track("clickEditPageButton", {
                    Catalogues: "editPageButton",
                    button_type: "clickExport",
                });
                window.addEventListener("click", this.closeEvent);
            } else {
                this.closeEvent({ target: null });
            }
        }
        closeEvent(e) {
            let objTarget = document.getElementById("outputDrop");
            let objMenu = this.$refs["outputMenu"]["$el"] as HTMLElement;
            if (objTarget != e.target && !objTarget.contains(e.target) && !objMenu.contains(e.target)) {
                this.showOutputDialog = false;
                window.removeEventListener("click", this.closeEvent);
            }
        }
        closeDrop() {
            this.showOutputDialog = false;
            window.removeEventListener("click", this.closeEvent);
        }
        toTheme() {
            if (this.showThemeDrop) {
                this.showThemeDrop = false;
                window.removeEventListener("click", this.closeThemeEvent);
                return;
            }
            this.activeFunc = "";
            this.showThemeDrop = true;
            window.addEventListener("click", this.closeThemeEvent);
        }
        closeThemeEvent(e) {
            let objTarget = this.$refs["themeDrop"] as HTMLElement;
            let objMenu = this.$refs["themeMenu"] as HTMLElement;
            if (objTarget != e.target && !objTarget.contains(e.target) && !objMenu.contains(e.target)) {
                this.showThemeDrop = false;
                window.removeEventListener("click", this.closeThemeEvent);
            }
        }
        closeTheme() {
            this.showThemeDrop = false;
            window.removeEventListener("click", this.closeThemeEvent);
        }
        toPrint() {
            this.$track("fastTool", "print file");
            window["_view"]._tool.endEdit();
            this.activeFunc = "";
            this.$store.commit("setStatus", {
                type: "showPrintContainer",
                data: true,
            });
            // let view= window['_view'];
            // import("@/app/utils/pdfDep.js").then(blobStream  => {
            //     view.toPrint(blobStream.default);
            // })
        }
        toShowPageSlider(index = 0, trackKey: string) {
            if (window.EDCONFIG.IS_SDK && !this.vip) {
                this.$openBuyPage("playSlider", "", {
                    pageIndex: 0,
                    isPageSlide: true,
                });
                return;
            }
            this.$bus.$emit("startPageSlides", index);
            this.closePageSlider();
            window["_view"]._tool.endEdit();
            window["_view"]._tool.selectObject(null);
            this.activeFunc = "";
            this.sensors.track("Play", {
                Catalogues: "toptoolbar",
                button_location: trackKey,
                from_page: "canva",
            });
        }
        get shareLinkCode() {
            return this.$store.state.ui.shareLinkCode;
        }
        set shareLinkCode(v) {
            this.$store.commit("setStatus", {
                type: "shareLinkCode",
                data: v,
            });
        }
        toShowFullScreen() {
            document.documentElement.requestFullscreen();
        }
        toShowShare(id?: number) {
            if (id !== void 0) {
                this.$store.commit("setStatus", {
                    type: "shareId",
                    data: id,
                });
            }
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "ShareBox",
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
        }
        get isEncrypt() {
            return this.$store.state.ui.isEncrypt;
        }
        set isEncrypt(v) {
            this.$store.commit("setStatus", {
                type: "isEncrypt",
                data: v,
            });
        }
        toEncrypt() {
            this.$track("fastTool", "encrypt file");
            if (!this.$checkAuth({ type: "encrypt" })) {
                return;
            }
            if (this.blockClick) {
                return;
            }
            if (!this.userInfo) {
                let ts: any = this;
                ts.$bus.$emit("login");
                return;
            }
            if (this.isEncrypt) {
                this.activeFunc = "";
                this.showEncryptDrop = true;
                this.$nextTick(() => {
                    (<HTMLInputElement>this.$refs.encryptDrop).focus();
                });
            } else {
                this.$store.commit("setStatus", {
                    type: "showCryptModal",
                    data: true,
                });
                this.$store.commit("setStatus", {
                    type: "cryptType",
                    data: "encry",
                });
            }
        }

        saveFile() {
            let ts: any = this;
            if (ts.isPreviewView) {
                // 群组阅读状态不进行保存
                return;
            }
            let urlSearch = ts.$store.state.ui.fileInfo;
            ts.$store.dispatch("autoSaveFile", { urlSearch }).catch(() => {});
        }
        showShareReadonly() {
            // 加上可编辑获取
            this.$edApi
                .getMembers({
                    id: this.userInfo.user_id,
                    shareId: this.$store.state.ui.shareId,
                    token: this.userInfo.token,
                })
                .then((data) => {
                    const member = data.member.map((item) => {
                        const temp_url = URL.createObjectURL(new Blob([JSON.stringify(item)], { type: "text/plain" }));
                        const uuid = temp_url.toString();
                        URL.revokeObjectURL(temp_url);
                        return {
                            ...item,
                            uuid,
                        };
                    });
                    this.$store.commit("setStatus", {
                        type: "shareMembers",
                        data: member,
                    });

                    let HTMLData = `<iframe frameborder="no" border="0" marginwidth="0" marginheight="0" width=800 height=800 src="${window["GLOBAL"].PUBLIC_OSS_HOST}${data.url}main.svg"></iframe>`;
                    this.$store.commit("setStatus", {
                        type: "shareLink",
                        data: data.domain + data.uuid,
                    });
                    if (data.code) {
                        this.$store.commit("setStatus", {
                            type: "shareLinkCode",
                            data: data.code,
                        });
                    }
                    this.$store.commit("setStatus", {
                        type: "shareHTML",
                        data: HTMLData,
                    });
                    if (data.option) {
                        this.$store.commit("setStatus", {
                            type: "shareType",
                            data: data.option,
                        });
                    }
                    this.$store.commit("setStatus", {
                        type: "shareExpire",
                        data: {
                            end_type: data.end_type,
                            end_time: data.end_time,
                        },
                    });
                    if (!this.internal && data.switch) {
                        this.$store.commit("setStatus", {
                            type: "shareUseable",
                            data: data.switch,
                        });
                    }
                    this.toShowShare();
                });
        }
        toShare(isManualSave: boolean, isBindPhoneShareFile = false) {
            if (window.EDCONFIG.IS_SDK) {
                this.sdkApp.promisePostMessage("SHARE_FILE");
                return;
            }

            // true 表示消息来自bus，false来自click事件
            if (!isManualSave && this.checkVipLimit("share")) {
                return;
            }
            this.sensors.track("Share", {
                Catalogues: "toptoolbar",
            });
            let getShareList = () => {
                // 获取分享列表
                return new Promise((RS, RJ) => {
                    let param = Object.assign({ fileType: "eddx" }, this.$store.getters.apiParam);
                    this.$edApi.getShareList(param).then((response) => {
                        RS(response);
                    });
                });
            };
            let checkExist = (arr) => {
                let objData = arr.data;
                let nowFile = this.$store.state.ui.fileInfo;
                let flag = false;
                let tempID = 0;
                let fileKey = this.$store.getters.fileKey;
                for (let i = 0; i < objData.length; ++i) {
                    let data = objData[i];
                    if (this.isPrivate) {
                        if (fileKey == data.file_key) {
                            let HTMLData = `<iframe frameborder="no" border="0" marginwidth="0" marginheight="0" width=800 height=800 src="${window["GLOBAL"].PUBLIC_OSS_HOST}${data.url}"></iframe>`;
                            this.$store.commit("setStatus", {
                                type: "shareLink",
                                data: data.domain + data.uuid,
                            });
                            if (data.code) {
                                this.$store.commit("setStatus", {
                                    type: "shareLinkCode",
                                    data: data.code,
                                });
                            }
                            this.$store.commit("setStatus", {
                                type: "shareHTML",
                                data: HTMLData,
                            });
                            this.$store.commit("setStatus", {
                                type: "switch",
                                data: data.switch,
                            });
                            this.$store.commit("setStatus", {
                                type: "shareExpire",
                                data: {
                                    end_type: data.end_type,
                                    end_time: data.end_time,
                                },
                            });
                            if (!this.internal && data.switch) {
                                this.$store.commit("setStatus", {
                                    type: "shareUseable",
                                    data: data.switch,
                                });
                            }
                            tempID = data.id;
                            flag = true;
                            break;
                        }
                    } else {
                        if (nowFile == data.obj) {
                            // 有已存在的分享
                            let HTMLData = `<iframe frameborder="no" border="0" marginwidth="0" marginheight="0" width=800 height=800 src="${window["GLOBAL"].PUBLIC_OSS_HOST}${data.url}main.svg"></iframe>`;
                            this.$store.commit("setStatus", {
                                type: "shareLink",
                                data: data.domain + data.uuid,
                            });
                            if (data.code) {
                                this.$store.commit("setStatus", {
                                    type: "shareLinkCode",
                                    data: data.code,
                                });
                            }
                            this.$store.commit("setStatus", {
                                type: "shareHTML",
                                data: HTMLData,
                            });
                            this.$store.commit("setStatus", {
                                type: "switch",
                                data: data.switch,
                            });
                            if (data.option) {
                                this.$store.commit("setStatus", {
                                    type: "shareType",
                                    data: data.option,
                                });
                            }
                            this.$store.commit("setStatus", {
                                type: "shareExpire",
                                data: {
                                    end_type: data.end_type,
                                    end_time: data.end_time,
                                },
                            });
                            if (!this.internal && data.switch) {
                                this.$store.commit("setStatus", {
                                    type: "shareUseable",
                                    data: data.switch,
                                });
                            }
                            tempID = data.id;
                            flag = true;
                            break;
                        }
                    }
                }
                if (isManualSave) {
                    this.blockClick = false;
                    flag && this.uploadShareSVG(tempID);
                    return;
                }
                if (!flag) {
                    if (this.isPrivate) {
                        this.shareFile();
                        return;
                    }
                    this.checkVerified().then((isBind) => {
                        if (!isBind) {
                            this.$store.commit("toShowPhoneDialog", { fromBtn: "shareBtn" });
                            this.$store.commit("setStatus", {
                                type: "ShareLoading",
                                data: false,
                            });
                            this.blockClick = false;
                        } else {
                            this.shareFile();
                        }
                    });
                } else {
                    this.shareFile(tempID);
                }
            };

            if (this.shareUUID) {
                this.saveFile();
                this.showShareReadonly();
                // 更新svg
                isManualSave = true;
                getShareList().then((data) => {
                    checkExist(data);
                });
                return;
            }

            this.activeFunc = "";
            if (this.isEncrypt) {
                !isManualSave && this.$edMessage.error(this.$t("lockedFile"));
                return;
            }
            if (this.blockClick) {
                return;
            }
            if (!this.userInfo) {
                let ts: any = this;
                ts.$bus.$emit("login");
                return;
            }
            if (!isManualSave) {
                this.$track("fastTool", "share file");
                this.$store.commit("setStatus", {
                    type: "ShareLoading",
                    data: true,
                });
                // this.toShowShare()
            }
            this.$store.commit("setStatus", {
                type: "shareId",
                data: null,
            });
            this.shareLinkCode = null;
            this.blockClick = true;

            window["_view"]._tool.endEdit();
            if (!isManualSave) {
                this.saveFile();
            }
            if (isBindPhoneShareFile) {
                this.shareFile(null, this.bindInfo);
            } else {
                getShareList().then((data) => {
                    checkExist(data);
                });
            }
        }
        updateEditShare() {
            let obj = null;
            if (this.internal) {
                obj = { uuid: this.shareUUID };
            } else {
                obj = {
                    uuid: this.shareUUID,
                    with_content: 1,
                };
            }
            let svgParams = Object.assign(obj, this.$store.getters.apiParam);
            return new Promise((res, rej) => {
                this.$edApi.getEditShareFileSign(svgParams).then((response) => {
                    this.uploadShareFileFunc(response, res);
                });
            });
        }
        uploadShareFileFunc(response, RS) {
            let promiseList = [];
            let ossData = response;
            if (!ossData) return;
            if (!this.internal) {
                ossData["host"] = ossData.action;
            }
            let content = window["_view"]._doc.saveToSvgStream(192, false, true);

            let svgFile = new Blob([content.documentElement.outerHTML], { type: "text/xml" });

            let svgFileName = "main.svg";
            let svgform = new FormData();
            let pages = window["_view"]._doc._pages;

            if (this.isPrivate) {
                // 私有化只需上传svg
                promiseList.push(
                    new Promise((rs, rj) => {
                        let param = {
                            url: `${ossData.host}/${ossData.path + ossData.uri}`,
                            sign: ossData.sign,
                            exp: ossData.exp,
                            file: svgFile,
                            contentType: "image/svg+xml",
                        };
                        this.$edApi
                            .privateUploadShareFile(param)
                            .then((res) => {
                                rs(null);
                            })
                            .catch((err) => {
                                console.log(err);
                            });
                    })
                );
                promiseList.push(
                    new Promise((rs, rj) => {
                        pages[0].toBitmap(
                            (blob) => {
                                let param = {
                                    url: `${ossData.host}/${ossData.img}`,
                                    sign: ossData.img_sign,
                                    exp: ossData.exp,
                                    file: blob,
                                    contentType: "image/png",
                                };
                                this.$edApi
                                    .privateUploadShareFile(param)
                                    .then((res) => {
                                        rs(null);
                                    })
                                    .catch((err) => {
                                        console.log(err);
                                    });
                            },
                            new egSize(150),
                            ".png"
                        );
                    })
                );
                Promise.all(promiseList).then(() => {
                    RS({
                        host: ossData.host,
                        url: ossData.path + ossData.uri,
                        cover_key: ossData.cover_key,
                        thumb_key: ossData.thumb_key,
                        previewImg: `${this.urls.apiUrl}/${ossData.img}`,
                    });
                });
                return;
            }

            const uploadShareSvg = () => {
                if (!this.internal) {
                    svgform.append("X-Amz-Algorithm", ossData["X-Amz-Algorithm"]);
                    svgform.append("X-Amz-Credential", ossData["X-Amz-Credential"]);
                    svgform.append("X-Amz-Date", ossData["X-Amz-Date"]);
                    svgform.append("Content-Type", "image/svg+xml");
                    svgform.append("X-Amz-Signature", ossData["X-Amz-Signature"]);
                    svgform.append("acl", ossData["acl"]);
                    svgform.append("Policy", ossData["Policy"]);
                    svgform.append("key", ossData.path + ossData.uri + svgFileName);
                    svgform.append("file", svgFile);
                } else {
                    svgform.append("OSSAccessKeyId", ossData.id);
                    svgform.append("policy", ossData.policy);
                    svgform.append("Signature", ossData.sign);
                    svgform.append("key", ossData.path + ossData.uri + svgFileName);
                    svgform.append("file", svgFile);
                }
                promiseList.push(
                    new Promise((rs, rj) => {
                        let param = { url: ossData.host, data: svgform };
                        this.$edApi
                            .uploadShareFile(param)
                            .then((res) => {
                                rs();
                            })
                            .catch((err) => {
                                console.log(err);
                            });
                    })
                );
            };
            Promise.all(promiseList).then((e) => {
                RS({ host: ossData.host, url: ossData.path + ossData.uri });
            });

            pages[0]?.toBitmap(
                (blob) => {
                    let imgform = new FormData();
                    if (!this.internal) {
                        imgform.append("X-Amz-Algorithm", ossData["X-Amz-Algorithm"]);
                        imgform.append("X-Amz-Credential", ossData["X-Amz-Credential"]);
                        imgform.append("X-Amz-Date", ossData["X-Amz-Date"]);
                        imgform.append("X-Amz-Signature", ossData["X-Amz-Signature"]);
                        imgform.append("Content-Type", "image/png");
                        imgform.append("acl", ossData["acl"]);
                        imgform.append("Policy", ossData["Policy"]);
                        imgform.append("key", ossData.path + ossData.uri + `preview.png`);
                        imgform.append("file", blob);
                    } else {
                        imgform.append("OSSAccessKeyId", ossData.id);
                        imgform.append("policy", ossData.policy);
                        imgform.append("Signature", ossData.sign);
                        imgform.append("key", ossData.path + ossData.uri + `preview.png`);
                        imgform.append("file", blob);
                    }
                    promiseList.push(
                        new Promise((rs, rj) => {
                            let param = { url: ossData.host, data: imgform };
                            this.$edApi
                                .uploadShareFile(param)
                                .then((res) => {
                                    rs();
                                })
                                .catch((err) => {
                                    console.log(err);
                                });
                        })
                    );
                },
                new egSize(150),
                ".png"
            );
            if (pages.length > 0) {
                pages.map((page, index) => {
                    let _page = window["_view"]._doc.pageByIndex(index);
                    if (!_page) return;
                    _page.toBitmap(
                        (blob) => {
                            let _svgFileName = `page-${index + 1}.svg`;
                            let _svgform = new FormData();
                            if (!this.internal) {
                                _svgform.append("X-Amz-Algorithm", ossData["X-Amz-Algorithm"]);
                                _svgform.append("X-Amz-Credential", ossData["X-Amz-Credential"]);
                                _svgform.append("X-Amz-Date", ossData["X-Amz-Date"]);
                                _svgform.append("Content-Type", "image/svg+xml");
                                _svgform.append("X-Amz-Signature", ossData["X-Amz-Signature"]);
                                _svgform.append("acl", ossData["acl"]);
                                _svgform.append("Policy", ossData["Policy"]);
                                _svgform.append("key", ossData.path + ossData.uri + _svgFileName);
                                _svgform.append("file", blob);
                            } else {
                                _svgform.append("OSSAccessKeyId", ossData.id);
                                _svgform.append("policy", ossData.policy);
                                _svgform.append("Signature", ossData.sign);
                                _svgform.append("key", ossData.path + ossData.uri + _svgFileName);
                                _svgform.append("file", blob);
                            }
                            promiseList.push(
                                new Promise((rs, rj) => {
                                    let param = { url: ossData.host, data: _svgform };
                                    this.$edApi
                                        .uploadShareFile(param)
                                        .then((res) => {
                                            rs();
                                        })
                                        .catch((err) => {
                                            console.log(err);
                                        });
                                })
                            );
                        },
                        new egSize(_page.width, _page.height),
                        ".svg",
                        // HidePageBreak | HidePageMargin | ToBitmap
                        0x00000040 | 0x00000080 | 0x00040178,
                        "#ffffff",
                        true
                    );
                });
            } else {
                uploadShareSvg();
            }
        }
        uploadShareSVG(id?: number) {
            // 上传预览图以及svg
            return new Promise((RS, RJ) => {
                if (id) {
                    let obj = null;
                    if (this.internal) {
                        obj = { shareId: id };
                    } else {
                        obj = {
                            shareId: id,
                            with_content: 1,
                        };
                    }
                    this.$edApi.getUpdateShareFileSign(Object.assign(obj, this.$store.getters.apiParam)).then((response) => {
                        return this.uploadShareFileFunc(response, RS);
                    });
                } else {
                    let obj = null;
                    if (this.internal) {
                        obj = this.$store.getters.apiParam;
                    } else {
                        obj = Object.assign({ with_content: 1 }, this.$store.getters.apiParam);
                    }
                    this.$edApi.getShareUploadSign(obj).then((response) => {
                        return this.uploadShareFileFunc(response, RS);
                    });
                }
                //this.axios.get(`https://test.edrawsoft.cn/viewer/public/api/user/${this.userInfo.user_id}/public?token=${this.userInfo.token}`).then((response) => {
            });
        }
        shareFile(id?: number, auth = {}) {
            // let cancelShare = () => { // 取消之前的分享文件
            //     return new Promise((RS, RJ) => {
            //         let param = Object.assign({fileId:id},this.$store.getters.apiParam)
            //         this.$edApi.cancelShare(param)
            //         .then((response) => {
            //             if(response.status == 'success')
            //                 RS()
            //         })
            //     })
            // }

            let shareFile = (data: any) => {
                // 上传分享文件信息到数据库，更新vuex数据

                let re = this.$store.state.ui.fileInfo.match(".*?/.*?/(.*)");
                let objName = (re && re[1]) || window["_view"]._doc._fileName + ".eddx";
                let params: any = {
                    title: window["_view"]._doc._fileName,
                    author: this.userInfo.nick_name,
                    url: data.url,
                    cloud: this.internal ? "oss" : "aws",
                    download: 0,
                    id: this.userInfo.user_id,
                    token: this.userInfo.token,
                    exp: Math.round((new Date().getTime() + 100000000000) / 1000),
                    obj: objName,
                    private: 0,
                    mode: 2,
                    option: this.internal ? 1 : 0,
                    platform: this.$store.state.publicStore.runPlatform,
                    v: this.appVersion,
                };
                if (!this.internal) {
                    params.switch = 0;
                }
                if (this.isWorkwx) {
                    params.option = 0;
                }
                Object.assign(params, auth);
                let imgUrl = this.isPrivate ? data.previewImg : `${data.host}/${data.url}preview.png`;
                this.$store.commit("setStatus", {
                    type: "shareData",
                    data: {
                        title: window["_view"]._doc._fileName,
                        imgUrl: imgUrl,
                    },
                });
                let ts: any = this;
                let url = `${this.urls.apiUrl}/api/user/${this.userInfo.user_id}/max/`;
                if (this.isPrivate) {
                    url = `${this.urls.apiUrl}/api/web/user/${this.userInfo.user_id}/max/`;
                    Object.assign(params, {
                        file_key: this.$store.getters.fileKey,
                        cover_key: data.cover_key,
                        thumb_key: data.thumb_key,
                    });
                }
                url += this.shareOption ? `reshare/${this.shareUUID}` : "share";
                this.sensors.track("startShareFile", {
                    Catalogues: "saveFileProcess",
                    savesource: "shareSave",
                    file_source: ts.$store.state.user.file_source,
                    template_type: ts.$store.state.user.template_type,
                });
                axios
                    .post(url, params, {
                        headers: {
                            Authorization: "Bearer " + this.userInfo.token,
                        },
                        cancelToken: new axios.CancelToken(function executor(c) {
                            ts.shareCancel = c;
                        }),
                    })
                    .then((response) => {
                        clearTimeout(this.shareTimer);
                        if (response.data.msg === "Shared") {
                            this.blockClick = false;
                            this.$store.commit("setStatus", {
                                type: "ShareLoading",
                                data: false,
                            });
                            this.$edMessage.warning(this.$t("editShared"));
                            return;
                        }
                        let HTMLData = `<iframe frameborder="no" border="0" marginwidth="0" marginheight="0" width=800 height=800 src="${window["GLOBAL"].PUBLIC_OSS_HOST}${data.url}main.svg"></iframe>`;
                        if (this.isPrivate) {
                            HTMLData = `<iframe frameborder="no" border="0" marginwidth="0" marginheight="0" width=800 height=800 src="${window["GLOBAL"].PUBLIC_OSS_HOST}${data.url}"></iframe>`;
                        }
                        if (response?.data?.data) {
                            this.$store.commit("setStatus", {
                                type: "shareLink",
                                data: response.data.data.link,
                            });
                            this.$store.commit("setStatus", {
                                type: "shareId",
                                data: response.data.data.id,
                            });
                        }
                        this.$store.commit("setStatus", {
                            type: "shareHTML",
                            data: HTMLData,
                        });
                        this.$store.commit("setStatus", {
                            type: "shareType",
                            data: this.internal && !this.isWorkwx ? 1 : 0,
                        });

                        this.$store.commit("setStatus", {
                            type: "ShareLoading",
                            data: false,
                        });
                        this.blockClick = false;
                        this.toShowShare(response?.data?.data?.id);
                    });
            };
            let updateShareFile = (data: any) => {
                let re = this.$store.state.ui.fileInfo.match(".*?/.*?/(.*)");
                let objName = (re && re[1]) || window["_view"]._doc._fileName + ".eddx";
                let params = {
                    exp: Math.round((new Date().getTime() + 10000000000) / 1000),
                    private: this.shareLinkCode ? 1 : 0,
                    mode: 2,
                    platform: this.$store.state.publicStore.runPlatform,
                    v: this.appVersion,
                };
                let ts: any = this;
                let url = `${this.urls.apiUrl}/api/user/${this.userInfo.user_id}/max/share/${id}`;
                if (this.isPrivate) {
                    url = `${this.urls.apiUrl}/api/web/user/${this.userInfo.user_id}/max/share/${id}`;
                }
                axios
                    .put(url, params, {
                        headers: {
                            Authorization: "Bearer " + this.userInfo.token,
                        },
                        cancelToken: new axios.CancelToken(function executor(c) {
                            ts.shareCancel = c;
                        }),
                    })
                    .then((response) => {
                        clearTimeout(this.shareTimer);
                        if (response.data.data && response.data.data.code) {
                            this.$store.commit("setStatus", {
                                type: "shareLinkCode",
                                data: response.data.data.code,
                            });
                        }
                        if (response.data.data && response.data.data.link) {
                            this.$store.commit("setStatus", {
                                type: "shareLink",
                                data: response.data.data.link,
                            });
                        }
                        let svgUrl = `${window["GLOBAL"].PUBLIC_OSS_HOST}${data.url}main.svg`;
                        if (this.isPrivate) {
                            svgUrl = `${window["GLOBAL"].PUBLIC_OSS_HOST}${data.url}`;
                        }
                        let HTMLData = `<iframe frameborder="no" border="0" marginwidth="0" marginheight="0" width=800 height=800 src="${svgUrl}"></iframe>`;

                        let pages = window["_view"]._doc._pages;
                        if (pages.length > 0) {
                            HTMLData = "";
                            pages.map((page, index) => {
                                svgUrl = `${window["GLOBAL"].PUBLIC_OSS_HOST}${data.url}page-${index + 1}.svg`;
                                HTMLData += `${
                                    index !== 0 ? "\n\n" : ""
                                }<iframe frameborder="no" border="0" marginwidth="0" marginheight="0" width=800 height=800 src="${svgUrl}"></iframe>`;
                            });
                        }

                        this.$store.commit("setStatus", {
                            type: "shareHTML",
                            data: HTMLData,
                        });

                        this.$store.commit("setStatus", {
                            type: "ShareLoading",
                            data: false,
                        });
                        this.blockClick = false;
                        if (this.isPrivate) {
                            this.toShowShare(id);
                            return;
                        }
                        this.checkVerified().then((isBind) => {
                            if (!isBind) {
                                this.$store.commit("toShowPhoneDialog", "shareBtn");
                                this.$store.commit("setShareId", id);
                                this.$store.commit("setStatus", {
                                    type: "shareId",
                                    data: id,
                                });
                            } else {
                                this.toShowShare(id);
                            }
                        });
                    });
            };
            // if(flag){
            //     cancelShare().then(() => {
            //         uploadShareSVG().then((data) => shareFile(data))
            //     })
            // }else{
            if (id) {
                this.uploadShareSVG(id).then((data) => {
                    clearTimeout(this.shareTimer);
                    updateShareFile(data);
                    this.blockClick = false;
                });
            } else {
                this.$bus.$emit("changeUserTaskStatus", {
                    id: 3,
                    status: 1,
                }); // 新手任务
                this.uploadShareSVG().then((data) => shareFile(data));
            }
            // }
            this.shareTimer = setTimeout(() => {
                // 15s 后强制取消
                let msg = this.$t("timeout") as string;
                this.showMessage({
                    type: 2,
                    imgType: 2,
                    content: msg,
                });
                this.shareCancel && this.shareCancel();
                this.$store.commit("setStatus", {
                    type: "ShareLoading",
                    data: false,
                });
                this.blockClick = false;
                clearTimeout(this.shareTimer);
            }, 15000);
        }

        downloadFile() {
            window["_view"]._tool.endEdit();
            this.$store.commit("toShow", {
                type: "showExport",
                data: true,
            });
        }
        toHome(from = "") {
            window["_view"]._tool.endEdit();

            if (window.EDCONFIG.IS_SDK) {
                this.sdkApp.promisePostMessage("BACK_TO_HOME");
                return;
            }

            this.$track("fastTool", "tohome", "logo icon");
            if (from === "clickLogo") {
                this.sensors.track("Back", {
                    Catalogues: "toptoolbar",
                });
            }
            if (this.isTeamsApp) {
                location.href = `${location.origin}${appConfig["sourcePath"]}`;
                return;
            }
            let url = `${window.location.origin}/online`;
            if (this.lang == "jp") {
                url = "https://www.edrawsoft.com/jp/tour/edrawmax.html";
            }
            let timer;
            const callback = (e) => {
                let data = e.data;
                if (data.action && data.action == "backHome") {
                    clearTimeout(timer);
                    window.open("", data.name);
                }
                window.removeEventListener("message", callback);
            };
            let opener = window.opener;
            if (opener) {
                window.addEventListener("message", callback);
                opener.postMessage(
                    {
                        action: "backHome",
                    },
                    "*"
                );
                timer = setTimeout(() => {
                    window.removeEventListener("message", callback);
                    window.opener = window.open(url);
                }, 300);
            } else {
                window.opener = window.open(url);
            }
        }

        getTeamFiles(params) {
            // userAxIns
            let userAxIns = axios.create({
                baseURL: this.urls.apiUrl + "/api/user/",
                withCredentials: true,
            });
            let { id, token, teamId } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .get(id + `/max/team/${teamId}/obj`, {
                        params: {
                            token,
                        },
                    })
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        }

        // 处理当预览文件已被其他人更改的情况
        refreshAndStart() {
            if (this.groupLock) {
                this.startGroupEdit();
                return;
            }
            location.reload();
            localStorage.setItem("isTabPanelReload", "1");
        }

        // group
        groupLock = false;
        async startGroupEdit() {
            let storage = localStorage;
            let teamId = storage.getItem("editTeamId");
            let objId = storage.getItem("editTeamObjId");
            let file_key = this.$store.getters.fileKey;

            /**
             * ws 兼容群组文件解锁
             */
            let wsurl = `${this.urls.apiUrl}/api/web/ws/mutual?file_key=${file_key}&team_id=${teamId}&token=${this.userInfo.token}`.replace(
                /http[s]*\:\/\//,
                "wss:"
            );
            let ws = new Ws(wsurl);
            ws.initWs();
            if (teamId != null && objId != null) {
                let param = Object.assign({ teamId, objId, file_key }, this.$store.getters.apiParam);

                this.$edApi.getEditTeamLock(param).then((data) => {
                    if (data.msg === "Owned by someone") {
                        this.$store.commit("setStatus", {
                            type: "isGroupLock",
                            data: true,
                        });
                        this.$store.commit("setStatus", {
                            type: "groupLockInfo",
                            data: data.data,
                        });
                        this.showGroupLockModal = true;
                        this.groupLock = true;
                    } else {
                        this.groupLock = false;
                        this.$store.commit("setStatus", {
                            type: "isGroupView",
                            data: false,
                        });
                        this.$store.commit("setStatus", {
                            type: "isPreviewView",
                            data: false,
                        });
                        this.$store.commit("setStatus", {
                            type: "isGroupLock",
                            data: false,
                        });
                        this.$nextTick(() => {
                            window["_view"].onsize();
                            window["_view"].fitToWindow();
                            if (this.$store.state.user.starter !== null && (this.$store.state.user.starter & 2) !== 2) {
                                setTimeout(() => {
                                    // this.$bus.$emit("starterGuide");
                                }, 1000);
                            }
                        });
                    }
                });

                // 隔一分钟获取锁
                window["getEditLockTimer"] = setInterval(() => {
                    this.$edApi.getEditTeamLock(param).then((data) => {});
                }, 60000);

                window.addEventListener("beforeunload", (e) => {
                    e.preventDefault();
                    (<any>this).$edApi.relEditTeamLock(param).then((res) => {
                        clearInterval(window["getEditLockTimer"]);
                    });
                });
            } else {
                if (this.isGroupLock) {
                    this.showGroupLockModal = true;
                }
            }
        }
        groupModalConfirm() {
            localStorage.setItem("isTabPanelReload", "0");
            this.showGroupLockModal = false;
        }

        // publish guide
        showGuidePublish() {
            if (!(localStorage && localStorage.getItem("guidePublish"))) {
                this.showGuideToPublish = true;
            }
        }
        setPublishStorageStatus() {
            this.showGuideToPublish = false;
            localStorage && localStorage.setItem("guidePublish", "1");
        }
        get expandTop() {
            return this.$store.getters.expandTop;
        }
        get userInfo() {
            return this.$store.state.user.userInfo;
        }
        get showDropdown() {
            return this.$store.state.ui.showDropdown;
        }
        set showDropdown(v: boolean) {
            this.$store.commit("setStatus", {
                type: "showDropdown",
                data: v,
            });
        }
        get activeTabType() {
            return this.$store.state.ui.activeTabType;
        }
        set activeTabType(v: number) {
            this.$store.commit("setStatus", {
                type: "activeTabType",
                data: v,
            });
            this.$store.commit("setStatus", {
                type: "showDropExpand",
                data: false,
            });
        }
        get fileNameSync() {
            return this.$store.state.ui.fileNameSync;
        }
        set fileNameSync(v) {
            window["_view"]._doc._fileName = v;
            this.$store.commit("setStatus", {
                type: "fileNameSync",
                data: v,
            });
        }
        get activeFunc() {
            return this.$store.state.ui.activeFunc;
        }
        set activeFunc(v) {
            this.$store.commit("setStatus", {
                type: "activeFunc",
                data: v,
            });
        }
        @Watch("fileNameSync")
        fileNameSyncChanged(v) {
            this.fileName = v;
        }

        // board 插件
        lockFlag = false;
        toBoardHome() {
            if (!this.isBoard) return;
            this.showMessage({
                sponsor: "toBoardHome",
                type: 0,
                imgType: 0,
                content: "现在回到新建页，将无法保存你当前画布已有的图形，是否继续回到新建页面",
            });
        }
        savePageImages() {
            let pages = window["_view"]._doc._pages;
            for (let i = 0; i < pages.length; ++i) {
                pages[i].toBitmap((blob) => {}, new egSize(150), ".png");
            }
        }
        async compressImg(zipId, blob) {
            async function decodeImg(blob) {
                let img = new Image();
                const url = URL.createObjectURL(blob);
                img.src = url;
                const loaded = new Promise((resolve, reject) => {
                    img.onload = () => resolve({});
                    img.onerror = () => reject(Error("Image loading error"));
                });
                await loaded;
                const canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                // Draw image onto canvas
                const ctx = canvas.getContext("2d");
                if (!ctx) throw new Error("Could not create canvas context");

                URL.revokeObjectURL(url);
                ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, img.width, img.height);
                return ctx.getImageData(0, 0, img.width, img.height);
            }
            let work = new Worker("./source/wasm/encoderWorker.js", { type: "module" });

            let arrayData = await decodeImg(blob);
            let obj = {
                id: zipId,
                data: arrayData.data,
                width: arrayData.width,
                height: arrayData.height,
                option: {},
            };
            work.postMessage({
                type: "pressImg",
                data: obj,
            });
            const loaded = new Promise((resolve, reject) => {
                work.onmessage = (e) => {
                    if (e.data.type == "done") {
                        resolve(e.data.data[0]);
                    }
                    work.terminate();
                };
                work.onerror = (err) => {
                    reject(err);
                    work.terminate();
                };
            });
            return await loaded;
        }

        async saveToBoard() {
            if (this.lockFlag) return;
            this.lockFlag = true;
            let setProcess = (num) => {
                this.$store.commit("setStatus", {
                    type: "LoadingProcess",
                    data: num > 1 ? 1 : num < 0 ? 0 : num,
                });
            };
            let loading = (type) => {
                let toggleLoading = (type) => {
                    if (type) {
                        setProcess(0);
                        this.$store.commit("setStatus", {
                            type: "loadingTextType",
                            data: "library",
                        });
                    }
                    this.$store.commit("setStatus", {
                        type: "Loading",
                        data: type,
                    });
                };
                toggleLoading(type);
            };
            loading(true);
            const ExportPer = 65536;
            let eddx = null,
                dataList = [],
                view = window["_view"];
            let pages = view._doc._pages;
            for (let i = 0; i < pages.length; i++) {
                let obj = {
                    index: i,
                    pageName: pages[i]._name,
                    svg: null,
                    image: null,
                };
                dataList.push(obj);
                setProcess(0.2);
            }
            await new Promise((rs, _) => {
                view._doc.saveToSvg(ExportPer, false, (data) => {
                    for (let item of dataList) {
                        for (let svg of data) {
                            if (item.index == svg.index) {
                                item.svg = svg.blob;
                            }
                        }
                    }
                    setProcess(0.42);
                    rs(null);
                });
            });
            await new Promise((rs, _) => {
                view.zipFile().then((e: any) => {
                    eddx = e[0];
                    rs(eddx);
                });
            });
            //  关闭生成png
            // await new Promise((rs, _) => {
            //     let zipImg = (blob) => {
            //         if(blob.size > 30 * 1024) {
            //             return new Promise((rs, rj) => {
            //                 let oldSize = blob.size;
            //                 let aaa = this.compressImg('asd', blob);
            //                 aaa.then(result => {
            //                     let blob = new Blob([result['data']], {type : 'image/png'});
            //                     console.log(`old: ${oldSize / 1024}kb`, `afterZip: ${blob.size/1024}kb`)
            //                     rs(blob)
            //                 }).catch(e => {
            //                     rs(blob)
            //                 })
            //             })
            //         } else {
            //             return Promise.resolve(blob)
            //         }
            //     }
            //     let list = [];
            //     let pages = view._doc._pages
            //     for(let i = 0; i < pages.length; ++i){
            //         list.push(new Promise((s, _) => {
            //             pages[i].toBitmap((blob) => {
            //                 zipImg(blob).then((result) => {
            //                     for(let item of dataList) {
            //                         if(item.index == i) {
            //                             item.image = result;
            //                         }
            //                     }
            //                     s()
            //                 })
            //             }, new egSize(1000), '.png');
            //         }))
            //     }
            //     Promise.all(list).then(() => {
            //         setProcess(1)
            //         rs();
            //     })
            // })
            window.parent.postMessage(
                {
                    eventName: "edrawmaxEvent",
                    action: "save",
                    data: dataList,
                    eddx,
                },
                "*"
            );
            this.lockFlag = false;
            loading(false);
        }

        back2Board() {
            window.parent.postMessage(
                {
                    eventName: "edrawmaxEvent",
                    action: "closeEditor",
                },
                "*"
            );
        }

        startPluginEdit() {
            this.$store.commit("setStatus", {
                type: "isPreviewView",
                data: false,
            });
            this.$nextTick(() => {
                window["_view"].onsize();
                window["_view"].fitToWindow();
            });
        }

        showAllDrop = false;

        handleShowAllDrop() {
            this.activeThis("tabsAll", 10);
            this.showAllDrop = !this.showAllDrop;
            this.closeExport();
            this.hidePublish();
            this.sensors.track("HamburgerMenu", {
                Catalogues: "toptoolbar",
            });
        }

        closeAllDrop() {
            this.showAllDrop = false;
        }

        hidePublish() {
            this.showPublishBtn = false;
        }

        get publishBtnVisible() {
            return !window.EDCONFIG.IS_SDK && !this.otherTypeFile && !this.isPrivate && !this.isTeamsApp;
        }

        exportLeft = 0;
        exportTop = 0;
        exportDropVisible = false;

        playSliderVisible = false;

        handleShowPlaySliderDrop() {
            this.playSliderVisible = true;
            this.exportDropVisible = false;
        }
        clickExport() {
            this.exportDropVisible = true;
            this.sensors.track("Export", {
                Catalogues: "toptoolbar",
            });
        }
        closeExport() {
            this.exportDropVisible = false;
            this.playSliderVisible = false;
        }

        get noLoginEditor() {
            return this.$store.state.user.noLoginEditor;
        }
        get isEdit() {
            return this.$store.state.ui.isEdit;
        }

        saveNewFile() {
            const canvas = window["_view"].saveTemplateThumbnailToCover();
            return Promise.all([
                window["_view"].zipFile(),
                new Promise((resolve) => {
                    canvas.toBlob((blob) => {
                        resolve(blob);
                    });
                }),
            ]);
        }
        uploadFile(obj) {
            const params = Object.assign(
                {
                    obj: obj.name,
                    size: obj.size,
                    platform: this.$store.state.publicStore.runPlatform,
                    cover: false,
                },
                this.$store.getters.apiParam
            );
            return this.$edApi.getCloudFileSign(params).then((res) => {
                let list = [];
                let url = res.data.obj;
                console.log("url123", url);
                let sign = res.data.sign;
                let exp = res.data.exp;
                list.push(Promise.resolve(url));

                // url encode
                let filePath = url.split("/");
                let fileName = encodeURIComponent(filePath.pop());
                url = filePath.join("/") + "/" + fileName;

                let ossParams = { url, exp, sign, file: obj.file, contentType: "application/octet-stream" };
                list.push(this.$edApi.uploadOSSFile(ossParams));

                // 上传封面图片
                if (res.data.img) {
                    let img_sign = res.data.img_up_sign;
                    let imageOssParams = { url: res.data.img, exp, sign: img_sign, file: obj.img, contentType: "image/png" };
                    list.push(this.$edApi.uploadOSSFile(imageOssParams));
                }

                return Promise.all(list);
            });
        }
        redirectUrl(objPath) {
            const matchResult = (objPath || "").match(/([^\/.]*)\.eddx/);
            const fileName = matchResult?.[1] ? matchResult[1] : "";
            let url = window.location.origin + appConfig.sourcePath + "app.html?" + this.$zipFileName(`obj=${objPath}&name=${fileName}`);
            location.href = url;
        }
        createFileAndRedirect() {
            this.$store.commit("setStatus", {
                type: "Loading",
                data: true,
            });
            this.saveNewFile()
                .then((data) => {
                    let fileData = data;
                    let dataObj = {
                        name: this.$tc("newFileName") + ".eddx",
                        size: fileData[0][0].size,
                        file: fileData[0][0],
                        img: fileData[1],
                    };
                    return this.uploadFile(dataObj);
                })
                .then((data) => {
                    this.redirectUrl(data[0]);
                })
                .finally(() => {
                    this.$store.commit("setStatus", {
                        type: "Loading",
                        data: false,
                    });
                });
        }
        nologinSave() {
            const toLogin = () => {
                return new Promise((RS, RJ) => {
                    let logAction = (userInfo) => {
                        userInfo.oldInfo = true;
                        this.sensors.registerPage({
                            uid: this.internal
                                ? userInfo.user_id
                                : (userInfo.ws_info ? userInfo.ws_info.ws_id : userInfo.ws && userInfo.ws.ws_id) || 0,
                        });
                        this.$store.commit("setState", { type: "userInfo", data: userInfo });
                        this.$store
                            .dispatch("updateVipStatus", {
                                user_id: this.userInfo.user_id,
                                token: this.userInfo.token,
                            })
                            .catch(() => {});
                        this.$store.dispatch("getUserInfo").then((e) => {
                            let userInfo = e.data;
                            if (userInfo.seo_source) {
                                this.sensors.registerPage({
                                    seo_source: userInfo.seo_source,
                                });
                            }
                            if (userInfo.selfutm_term) {
                                this.sensors.registerPage({
                                    selfutm_term: userInfo.selfutm_term,
                                });
                            }
                        });
                        let lang = getHashString("lang");
                        if (ValidLang.includes(lang)) {
                            this.$store.dispatch("setUserPrefer", { language: lang });
                        }
                    };
                    let success = (userInfo: any) => {
                        logAction(userInfo);
                        RS(null);
                    };
                    let fail = () => {
                        $edAuth.show();
                    };
                    let utm_term = this.utm_term ? `4-${this.utm_term}` : "";
                    let loginParams = {
                        pid: this.appPid,
                        seo_source: this.$store.state.user.seo_source || utm_term,
                    };
                    $edAuth
                        .checkLocalCookie(true, loginParams)
                        .then((userInfo: any) => {
                            logAction(userInfo);
                            RS(null);
                        })
                        .catch(() => {
                            $edAuth.auth(success, fail, loginParams);
                        });
                });
            };

            toLogin().then(() => {
                this.$edApi.getUserLimit({ id: this.userInfo.user_id, token: this.userInfo.token, platform: "web" }).then((res) => {
                    if (res.data.limit !== null && res.data.num >= res.data.limit) {
                        this.showAppLimitFileModal = true;
                    } else {
                        this.createFileAndRedirect();
                    }
                });
            });
        }

        get vipTemplateMark() {
            return this.$store.state.vipState.vipTemplateMark;
        }

        get cummunityVipTemplateMark() {
            return this.$store.state.vipState.cummunityVipTemplateMark;
        }

        get vipSymbolMark() {
            return this.$store.state.vipState.vipSymbolMark;
        }
        get vipShapeNum() {
            return this.$store.state.vipState.vipShapeNum;
        }
        get vipPageTheme() {
            return this.$store.state.vipState.vipPageTheme;
        }
        get vipPageColor() {
            return this.$store.state.vipState.vipPageColor;
        }
        get vipPageConnect() {
            return this.$store.state.vipState.vipPageConnect;
        }
        get vipPageAutoBeautify() {
            return this.$store.state.vipState.vipPageAutoBeautify;
        }
        get vipPageBackground() {
            return this.$store.state.vipState.vipPageBackground;
        }
        get vipDoctWatermark() {
            return this.$store.state.vipState.vipDoctWatermark;
        }
        get vipDocPageNum() {
            return this.$store.state.vipState.vipDocPageNum;
        }
        get vipMath() {
            return this.$store.state.vipState.vipMath;
        }
        get vipPPTFont() {
            return this.$store.state.vipState.vipPPTFont;
        }
        get isUsedVipState() {
            return this.$store.getters.isUsedVipState;
        }

        firstShowVipPopover = false;
        get userTodayFirstShowed() {
            const user_id = this.userInfo ? this.userInfo.user_id : "";
            const day = new Date().getDate();
            const list = JSON.parse(localStorage.getItem("showedVipPopover") || "[]");
            const hasShow = list.some((item) => {
                const [itemId, itemDay] = item.split("-");
                return (itemId === user_id || Number(itemId) === Number(user_id)) && Number(itemDay) === day;
            });
            return !this.firstShowVipPopover && hasShow;
        }

        hoverVipPopover() {
            if (this.vip) return;
            const trackKey = (key) => {
                this.sensors.track("popBuyNowFloatWindow", {
                    Catalogues: "payPath",
                    is_unlimited_ai: !!this.purchaseBubble,
                    upgrade_trigger: "hoverNowFloatWindow",
                    trial_vip_benefit: key,
                });
            };
            if (!this.isUsedVipState) {
                trackKey("none");
            } else {
                if (this.vipTemplateMark || this.cummunityVipTemplateMark) {
                    trackKey(this.cummunityVipTemplateMark ? "cummunityVipTemplate" : "vipTemplate");
                }
                if (this.vipSymbolMark) {
                    trackKey("library");
                }
                if (this.vipShapeNum) {
                    trackKey("symbolsExceedLimit");
                }
                if (this.vipPageTheme) {
                    trackKey("theme");
                }
                if (this.vipPageColor) {
                    trackKey("themeColor");
                }
                if (this.vipPageConnect) {
                    trackKey("connector");
                }
                if (this.vipPageAutoBeautify) {
                    trackKey("oneClickBeautify");
                }
                if (this.vipPageBackground) {
                    trackKey("setBackgroundPop");
                }
                if (this.vipDoctWatermark) {
                    trackKey("customMark");
                }
                if (this.vipDocPageNum) {
                    trackKey("pageIcon");
                }
                if (this.vipMath) {
                    trackKey("formulaEditor");
                }
                if (this.vipPPTFont) {
                    trackKey("text");
                }
            }
        }

        mounted() {
            this.$bus.$on("msgOperation", (data) => {
                if (data.sponsor == "toBoardHome") {
                    if (data.data) location.href = `${window.location.origin}${appConfig["sourcePath"]}`;
                }
            });

            window.addEventListener("load", () => {
                if (location.hash !== "#editTeam") {
                    return;
                }
                let isTabPanelReload = localStorage.getItem("isTabPanelReload");
                let num = 0;
                if (isTabPanelReload !== "1" || (isTabPanelReload === "1" && !this.userInfo)) {
                    const timer = setInterval(() => {
                        if (num >= 20) {
                            clearInterval(timer);
                            return;
                        } else {
                            num++;
                            isTabPanelReload = localStorage.getItem("isTabPanelReload");
                            if (isTabPanelReload === "1" && this.userInfo) {
                                this.$nextTick(() => {
                                    setTimeout(() => {
                                        this.startGroupEdit();
                                        localStorage.setItem("isTabPanelReload", "0");
                                    }, 200);
                                });
                                clearInterval(timer);
                            }
                        }
                    }, 100);
                } else if (isTabPanelReload === "1") {
                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.startGroupEdit();
                            localStorage.setItem("isTabPanelReload", "0");
                        }, 100);
                    });
                }
            });

            this.$bus.$on("nologinSave", this.nologinSave);
        }
        bindInfo = null;

        get purchaseBubble() {
            return this.$store.state.publicStore.purchaseBubble;
        }

        get vipPopoverName() {
            if (!this.vipState && !this.isUsedVipState) {
                return "NoVipPopover";
            }
            const isVipMark = this.isUsedVipState;
            if ((!this.vipState && isVipMark) || (isVipMark && !this.userTodayFirstShowed)) {
                return "VipPopover";
            }
        }

        pptSdkSaveFile(sdkToMaxFrom) {
            this.saveNewFile()
                .then((data) => {
                    let fileData = data;
                    let dataObj = {
                        name: this.$tc("newFileName") + ".eddx",
                        size: fileData[0][0].size,
                        file: fileData[0][0],
                        img: fileData[1],
                    };
                    return this.uploadFile(dataObj);
                })
                .then((data) => {
                    const matchResult = (data[0] || "").match(/([^\/.]*)\.eddx/);
                    const fileName = matchResult?.[1] ? matchResult[1] : "";
                    let url = window.location.origin + "/online/app.html?" + this.$zipFileName(`obj=${data[0]}&name=${fileName}`);
                    if (data[0]) {
                        this.sdkApp.promisePostMessage("SAVE_SUCCESS_TO_ONLINE", { url, sdkToMaxFrom });
                    }
                });
        }

        created() {
            this.refreshFilename(this.fileNameSync);
            let ts: any = this;

            ts.$bus.$on("shareFile", (isManualSave = false, isBindPhoneShareFile = false, bindInfo) => {
                this.bindInfo = bindInfo;
                this.toShare(isManualSave, isBindPhoneShareFile);
            });
            ts.$bus.$on("toHome", () => {
                this.toHome();
            });
            ts.$bus.$on("updateEditShare", () => {
                this.updateEditShare();
            });
            ts.$bus.$on("showTabsMenu", (data) => {
                ts.handleShowAllDrop();
                ts.$nextTick(() => {
                    let { type } = data;
                    const allDropEle = ts.$refs.allDrop.$el as HTMLElement;
                    const children = allDropEle.children[type] as HTMLElement;
                    if (ts.activeTabType !== type) {
                        if (ts.showDropdown) {
                            ts.activeTabType = type;
                        }
                        ts.$store.commit("setStatus", {
                            type: "dropType",
                            data: type,
                        });
                        if (ts.showDropdown) {
                            ts.setDropsPos(children, type);
                        }
                    }
                });
            });
            ts.$bus.$on("toPublish", () => {
                this.toShowPublish();
            });
            ts.$bus.$on("showPublishGuide", () => {
                this.showGuidePublish();
            });
            ts.$bus.$on("closeOuputMenu", () => {
                this.closeDrop();
            });
            ts.$bus.$on("toShowShare", () => {
                this.toShowShare();
            });
            ts.$bus.$on("toSearch", () => {
                this.toSearch();
            });
            ts.$bus.$on("showThisDrop", (e, type) => {
                this.showThisDrop(e, type);
            });
            ts.$bus.$on("closeShowAll", () => {
                this.closeAllDrop();
            });
            ts.$bus.$on("changePopoverVisible", (val) => {
                if (!this.$refs.vipPopover) return;
                this.firstShowVipPopover = val;
                const dom = this.$refs.vipPopover as HTMLElement;
                if (dom) {
                    dom.style.display = val ? "block" : "none";
                }
            });

            this.$bus.$on("sdkToOnline", (val: string) => {
                console.log("sdkToOnline sval", val);
                this.pptSdkSaveFile(val);
            });
        }
        beforeDestroy() {
            let ts: any = this;
            ts.$bus.$off("shareFile");
            ts.$bus.$off("toHome");
            ts.$bus.$off("showTabsMenu");
            ts.$bus.$off("toPublish");
            ts.$bus.$off("closeOuputMenu");
            ts.$bus.$off("toShowShare");
            ts.$bus.$off("toSearch");
            ts.$bus.$off("showThisDrop");
            ts.$bus.$off("closeShowAll");
            ts.$bus.$off("nologinSave", this.nologinSave);
            ts.$bus.$off("changePopoverVisible");
            ts.$bus.$on("sdkToOnline");
        }
    }
</script>
